<template>
    <div>
      <v-dialog max-width="887px" class="cdz pa-4" v-model="uploadBulkAudienceRoles" center>
        <v-form ref="form" lazy-validation>
          <v-card class="pa-6">
            <div class="mb-7 text-h6">
              Upload File
            </div>
  
            <div class="d-flex justify-center mb-6 bg-surface-variant">
              <div class="box2" @dragover.prevent>
                <div
                  class="w-100 d-flex flex-row justify-center"
                  style="margin-top: 80px"
                >
                  <img src="../../../public/svgs/xlsx_icon 1.svg" />
                </div>
  
                <div class="w-100 d-flex flex-row justify-center mt-4">
                  <div>
                    <div class="font-weight-light text-center">
                      Drag and drop a file or
                      <div class="uplaodbtn2">
                        browse file
                        <input
                          type="file"
                          @change="handleFileUpload"
                          name="csv"
                        />
                      </div>
                      <p class="grey--text">(Supported only .csv file)</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <v-card-actions class="px-9 pb-6">
              <v-btn text @click="downloadSampleCSV" class="mx-2 blue--text">
                <img class="mr-2" src="../../../public/svgs/fi_share.svg" />
                <span class="blue--text"> Download Template Excel </span>
              </v-btn>
              <v-spacer></v-spacer>
              <v-btn
                rounded
                width="102px"
                height="48px"
                outlined
                class="btn outline-btn pa-4"
                @click="closeUploadBulkAudienceRoles"
                >Cancel</v-btn
              >
              <!-- @click="uploadAudienceRoles" -->
              <v-btn
                depressed
                rounded
                disabled
                width="102px"
                height="48px"
                class="btn primary-btn pa-4"
                >Upload</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <v-dialog class="cdz" max-width="600px" v-model="uploadingRolesDialog">
        <v-card class="pa-6">
          <div>
            <h2>Upload File</h2>
            <div v-if="failedRowCount <= 0" class="mt-2">Please wait completing upload...</div>
            <div v-else class="mt-2">Invalid records in Excel. Please correct and re-upload</div>
            <v-progress-linear value="100" rounded height="20" class="mt-4" color="blue"></v-progress-linear>
            <p>{{fileName}}</p>
          </div>

          <v-row justify="end" class="mt-4">
            <v-col cols="auto">
              <p style="font-size: 14px;" class="success--text mb-0">
                Successful: {{ successfullRowCount }}
              </p>
            </v-col>
            <v-col cols="auto">
              <p style="font-size: 14px;" class="error--text mb-0">
                Unsuccessful: {{ failedRowCount }}
              </p>
            </v-col>
          </v-row>
          <!-- Actions -->
            <v-row no-gutters align="center" class="w-100 pt-4">
              <!-- Left: Download Error Log -->
              <v-col cols="6" class="d-flex align-center">
                <div class="d-flex align-center">
                  <img class="mr-2" :src="failedRowCount > 0 ? require('../../assets/enable_share.svg') : require('../../assets/fi_share.svg')" alt="Download Icon"/>
                  <p
                    class="mb-0 cursor-pointer pt-1"
                    @click="(failedRowCount > 0) && downloadFailedRows()"
                    :style="{ color: failedRowCount > 0 ? 'var(--blue-01)' : 'grey' }"
                  >
                    DOWNLOAD ERROR LOG
                  </p>
                </div>
              </v-col>
              <!-- Right: Cancel and Upload Buttons -->
              <v-col cols="6" class="d-flex justify-end align-center">
                <v-btn
                @click="clearDataAndClose"
                depressed
                class="btn outline-btn mx-2"
                large
                outlined
                rounded>
                  Cancel
                </v-btn>
                <v-btn
                v-if="failedRowCount <= 0"
                  depressed
                  rounded
                  class="btn primary-btn"
                  :loading="uploadingAudienceRoles"
                  @click="uploadAudienceRoles"
                  >
                  Upload
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-dialog>
        <v-dialog v-model="showConfirmDialog" class="cdz" max-width="400px" min-height="294px" persistent>
        <v-card class="text-subtitle-1">
          <v-container fluid class="pa-2">
            <v-card-text class="text-center d-flex flex-column align-center" >
              <img src="../../assets/upload-confirmed.svg">
              <p class="text-h5 text-center py-4">Create Role Mapping Created Successfully</p>
              <v-btn class="btn primary-btn w-100" large  @click="closeUploadConfirmDialog" rounded>Ok</v-btn>
            </v-card-text>
          </v-container>
        </v-card>
      </v-dialog>
      <v-card
        height="64px"
        width="100%"
        class="background ml-4 mr-6 my-0 px-4 transparent elevation-0 d-flex flex-row justify-space-between align-center"
        style="
          position: fixed;
          z-index: 200;
          top: 0;
          width: 98%;
          padding-top: 16px;
        "
      >
        <v-card-title class="pl-0 ml-0">
          <p
            class="breadcrumb-text-unselected underline-on-hover cursor"
            @click="$router.push('/masters')"
          >
            Masters
          </p>
          <v-icon
            class="breadcrumb-arrow-unselected"
            style="margin-top: 6px !important"
            >mdi-chevron-right</v-icon
          >
          <v-menu offset-y class="menuZindex">
            <template v-slot:activator="{ on }">
              <span
                 v-on="!dialog ? on : null"
                @click="dialog = false"
                :class="['cursor', dialog ? 'breadcrumb-text-unselected underline-on-hover' : 'breadcrumb-text']"
                style="margin-top: 2px"
              >
                Role Mapping
                <v-icon
                  :class="dialog ? 'breadcrumb-arrow-unselected' : 'breadcrumb-arrow cursor'"
                  style="margin-top: 6px !important"
                >
                  {{ dialog ? 'mdi-chevron-right' : 'mdi-chevron-down' }}
                </v-icon>
              </span>
            </template>
            <MastersDropdownComponent v-if="!dialog" />
          </v-menu>

          <div v-if="dialog" class="d-flex">
            <p class="breadcrumb-text">{{ formActionType }}</p>
            <v-icon class="breadcrumb-arrow cursor" style="margin-top: 5px !important">
              mdi-chevron-down
            </v-icon>
          </div>
        </v-card-title>
        <UserNavMenu/>
      </v-card>
      <div fluid class="px-10 pad">
        <v-row>
          <v-col>
            <v-row v-if="dialog" class="px-0 pt-4">
              <div class="w-100">
                <div class="mb-4 text-h6">
                  {{ formActionType }} Role Mapping
                </div>
                <div v-if="['Create', 'Update'].includes(formActionType)">
                  <v-form ref="form" lazy-validation>
                    <v-card id="myScroll" rounded flat class="form-card pa-0">
                      <v-card-text>
                        <v-row class="py-0 my-0">
                          <v-col class="py-0 my-0" cols="6">
                            <v-autocomplete
                            outlined
                            class="rounded-xl"
                            v-model="department_group"
                            :items="audienceRoleGroups"
                            @change="handleDepartmentGroupChange"
                            item-text="name"
                            item-value="id"
                            label="Department Group*"
                            :rules="[(v) => !!v || 'Department Group is required']"
                            required>
                              <template v-slot:label>
                                Department Group<span class="required"> *</span>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col class="py-0 my-0" cols="6">
                            <v-autocomplete
                            outlined
                            class="rounded-xl"
                            v-model="department"
                            :items="departmentsList"
                            :disabled="department_group === ''"
                            @change="handleDepartmentChange"
                            label="Department*"
                            :rules="[(v) => !!v || 'Department is required']"
                            required>
                              <template v-slot:label>
                                Department<span class="required"> *</span>
                              </template>
                            </v-autocomplete>
                          </v-col>                          
                        </v-row>
                        <v-row class="py-0 my-0">
                          <v-col class="py-0 my-0" cols="6">
                            <v-autocomplete
                            outlined
                            class="rounded-xl"
                            v-model="HRIS_unique_role"
                            :items="hrisUniqueRolesList"
                            :disabled="department === ''"
                            :search-input.sync="tags['hrisUniqueRole']"
                            :loading="loadingRoles['hrisUniqueRole']"
                            hide-details
                            :hide-no-data="loadingRoles['hrisUniqueRole']"
                            item-text="hrisUniqueRole"
                            item-value="hrisUniqueRole"
                            :filter="customFilter"
                            @change="handleAudienceRoleChange"
                            @focus="onAutocompleteInteraction('hrisUniqueRole')"
                            clearable
                            rounded
                            no-data-text="No matching records found"
                            :menu.sync="menu"
                            label="HRIS Unique Role*"
                            :rules="[(v) => !!v || 'HRIS Unique code is required']"
                            required>
                              <template v-slot:label>
                                HRIS Unique Role<span class="required"> *</span>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col class="py-0 my-0" cols="6">
                            <v-text-field
                            readonly
                            outlined
                            class="py-0 my-0 rounded-xl"
                            disabled
                            v-model="roles"
                            label="Role"
                            :rules="[(v) => !!v || 'Hris Unique Role name is required']"
                            required>
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row class="py-0 my-0">
                          <v-col class="py-0 my-0" cols="6">
                            <v-autocomplete
                            label="Level*"
                            outlined
                            v-model="level"
                            required
                            :rules="[(v) => !!v || 'Level is required']"
                            class="py-0 my-0 rounded-xl"
                            :items="levels"
                            item-text="name" item-value="name" flat
                            :disabled="levels.length === 0">
                              <template v-slot:label>
                                Level<span class="required"> *</span>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col class="py-0 my-0" cols="6">
                            <v-autocomplete
                            label="Campaign*"
                            outlined
                            v-model="campaignId"
                            required
                            :rules="[(v) => !!v || 'Campaign is required']"
                            class="py-0 my-0 rounded-xl"
                            :items="campaignsList"
                            item-text="name" item-value="id" flat>
                              <template v-slot:label>
                                Campaign<span class="required"> *</span>
                              </template>
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row class="py-0 my-0">
                          <v-col class="py-0 my-0" cols="6">
                            <v-autocomplete
                            label="Interviewer/Hiring Manager Scope*"
                            outlined
                            v-model="interviewerScope"
                            required
                            :rules="[(v) => !!v || 'Interviewer/Hiring Manager Scope is required']"
                            class="py-0 my-0 rounded-xl"
                            :items="interviewerScopeList"
                            flat>
                              <template v-slot:label>
                                Interviewer/Hiring Manager Scope<span class="required"> *</span>
                              </template>
                            </v-autocomplete>
                          </v-col>
                        </v-row>
                        <v-row class="d-flex justify-space-between ma-0">
                            <div class="d-flex pt-2">
                              Select the stages applicable to this role
                            </div>
                            <div class="d-flex gap-4">
                              <v-checkbox label="Screening" v-model="screeningRequired"></v-checkbox>
                              <v-checkbox label="Mains" v-model="mainsRequired"></v-checkbox>
                              <v-checkbox label="Demo" v-model="demoRequired"></v-checkbox>
                              <v-checkbox label="Interview" disabled  v-model="interviewRequired"></v-checkbox>
  
                            </div>
                        </v-row>
                        <v-row class="py-0 my-0">
                           <v-col class="py-0 my-0" cols="6">
                            <v-text-field
                             v-model="interviewRounds"
                             label="Interview Rounds (Min 1, Max 5)"
                             type="number"
                             class="rounded-xl"
                             placeholder="1"
                             min="1"
                             :max="maxInterviewRounds"
                             outlined
                             required
                             @change="restrictInterviewRounds($event)"
                             hint=""
                             persistent-hint
                             :rules="[
                               v => v !== '' && v !== null && v !== undefined || ' Type is required',
                               v => Number(v) > 0 || 'Interview Rounds must be a positive number',
                               v => Number(v) < maxInterviewRounds + 1 || 'Interview Rounds must not exceed maximum interview rounds',
                               v => Number.isInteger(Number(v)) || 'Interview Rounds must be an integer'
                             ]">
                             </v-text-field>
                           </v-col>
                        </v-row>
                        <div v-for="(round) in interviewRoundsCards"
                        :key="`interviewRound${round}`" class="interview-rounds-card rounded-xl my-4 pa-4 d-flex flex-column gap-2">
                          <div> Interview Round {{round}} <span class="required"> *</span></div>
                          <v-row class="py-0 my-0">
                            <v-col class="py-0 my-0" cols="6">
                              <v-autocomplete
                              label="Interviewer"
                              v-model="interviewerHRISUniqueRolesRoundWise[round]"
                              :items="roundWiseAudienceRoleItems[round] || audienceRolesList"
                              :loading="loadingRoles['interviewerHRISUniqueRolesRoundWise'][round]"
                              :hide-no-data="loadingRoles['interviewerHRISUniqueRolesRoundWise'][round]"
                              clearable
                              outlined
                              required
                              multiple
                              no-data-text="No matching records found"
                              :menu.sync="menu"
                              class="rounded-xl"
                              :filter="customFilter"
                              :search-input.sync="tags['interviewerHRISUniqueRolesRoundWise'][round]"
                              @focus="onAutocompleteInteraction('interviewerHRISUniqueRolesRoundWise', round)"
                              @input="limitInterviewersSelection(round)"
                              item-text="hrisUniqueRole"
                              item-value="hrisUniqueRole"
                              flat
                              :rules="[ v => !!v || 'Interviewers are required', v => (v && v.length <= interviewRoleSelectionLimit) || `Maximum ${interviewRoleSelectionLimit} interviewers allowed` ]"
                              solo>
                                <template v-slot:label>
                                  Interviewer<span class="required"> *</span>
                                </template>
                                <template #selection="{ item, index }">
                                  <v-chip v-if="index < 2" text-color="#3F41D1" color="#CFD5F1" @click:close="deleteChip(item.hrisUniqueRole, interviewerHRISUniqueRolesRoundWise[round])" close-icon="mdi-close" close>
                                    {{ item.hrisUniqueRole}}
                                  </v-chip>
                                  <v-tooltip v-else-if="index === 2" bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-chip v-bind="attrs" v-on="on" class="mr-1"  text-color="#3F41D1" color="#CFD5F1">
                                        +{{ interviewerHRISUniqueRolesRoundWise[round]?.length - 2 }}
                                      </v-chip>
                                    </template>
  
                                    <template v-slot:default>
                                      <div>
                                        <div v-for="(interviewerHRISUniqueRole, index) in interviewerHRISUniqueRolesRoundWise[round]?.slice(2)" :key="index">
                                          {{ interviewerHRISUniqueRole  }}
                                        </div>
                                      </div>
                                    </template>
                                  </v-tooltip>
                                </template>
                              </v-autocomplete>
                            </v-col>
                            <v-col class="py-0 my-0" cols="6">
                              <v-autocomplete
                              outlined
                              class="rounded-xl"
                              v-model="slotApproverHRISUniqueRoleRoundWise[round]"
                              :items="roundWiseAudienceRoleItems[round] || audienceRolesList"
                              :filter="customFilter"
                              no-data-text="No matching records found"
                              :menu.sync="menu"
                              :loading="loadingRoles['slotApproverHRISUniqueRoleRoundWise'][round]"
                              :hide-no-data="loadingRoles['slotApproverHRISUniqueRoleRoundWise'][round]"
                              :search-input.sync="tags['slotApproverHRISUniqueRoleRoundWise'][round]"
                              @focus="onAutocompleteInteraction('slotApproverHRISUniqueRoleRoundWise', round)"
                              item-text="hrisUniqueRole" item-value="hrisUniqueRole"
                              :rules="[(v) => !!v || 'Slot Approver is required']"
                              required>
                                <template v-slot:label>
                                  Slot Approver<span class="required"> *</span>
                                </template>
                              </v-autocomplete>
                            </v-col>
                          </v-row>
                          <v-row class="py-0 my-0">
                            <v-col class="py-0 my-0" cols="6">
                              <v-text-field
                              v-model="numberOfHiringManagersRoundWise[round]"
                              type="number"
                              class="rounded-xl"
                              placeholder="1"
                              min="1"
                              max="3"
                              outlined
                              required
                              @change="handleHiringManagerCountChange(round)"
                              :rules="[
                                v => v !== '' && v !== null && v !== undefined || 'Number of Hiring Managers is required',
                                v => Number.isInteger(Number(v)) || 'Number of Hiring Managers must be an integer',
                                v => Number(v) >= 1 && Number(v) <= 3 || 'Number of Hiring Managers must be between 1 and 3'
                              ]">
                                <template v-slot:label>
                                  <div class="d-flex align-start">
                                    Number of Hiring Managers (Min 1, Max 3)<span class="required"> *</span>
                                    <span class="pl-1">
                                      <InfoTooltip text="Assign Hiring Managers In The Order Of Priority. The Primary Hiring Manager Will Receive The Request First. If They Are Unavailable Or Do Not Take Action, The Request Can Be Handled By The Secondary Hiring Manager, Followed By The Tertiary Hiring Manager, And So On." />
                                    </span>
                                  </div>
                                </template>
                              </v-text-field>
                            </v-col>
                            <v-col class="py-0 my-0" cols="6">
                              <v-autocomplete
                              outlined
                              class="rounded-xl"
                              :value="getHiringManager(round, 0)"
                              @input="setHiringManager(round, 0, $event)"
                              :items="roundWiseAudienceRoleItems[round] || audienceRolesList"
                              :filter="customFilter"
                              no-data-text="No matching records found"
                              :menu.sync="menu"
                              :loading="loadingRoles['primaryHiringManagerHRISUniqueRolesRoundWise'][round]"
                              :hide-no-data="loadingRoles['primaryHiringManagerHRISUniqueRolesRoundWise'][round]"
                              :search-input.sync="tags['primaryHiringManagerHRISUniqueRolesRoundWise'][round]"
                              @focus="onAutocompleteInteraction('primaryHiringManagerHRISUniqueRolesRoundWise', round)"
                              item-text="hrisUniqueRole" item-value="hrisUniqueRole"
                              :rules="[(v) => !!v || 'Primary Hiring Manager is required']"
                              required>
                                <template v-slot:label>
                                  Primary Hiring Manager<span class="required"> *</span>
                                </template>
                              </v-autocomplete>
                            </v-col>
                          </v-row>
                          <v-row class="py-0 my-0">
                            <v-col v-if="Number(numberOfHiringManagersRoundWise[round]) > 1" class="py-0 my-0" cols="6">
                              <v-autocomplete
                              outlined
                              class="rounded-xl"
                              :value="getHiringManager(round, 1)"
                              @input="setHiringManager(round, 1, $event)"
                              :items="hiringManagerItemsForRound(round, [getHiringManager(round, 0)])"
                              :filter="customFilter"
                              no-data-text="No matching records found"
                              :menu.sync="menu"
                              :loading="loadingRoles['secondaryHiringManagerHRISUniqueRolesRoundWise'][round]"
                              :hide-no-data="loadingRoles['secondaryHiringManagerHRISUniqueRolesRoundWise'][round]"
                              :search-input.sync="tags['secondaryHiringManagerHRISUniqueRolesRoundWise'][round]"
                              @focus="onAutocompleteInteraction('secondaryHiringManagerHRISUniqueRolesRoundWise', round)"
                              item-text="hrisUniqueRole" item-value="hrisUniqueRole"
                              :rules="[
                                (v) => !!v || 'Secondary Hiring Manager is required',
                                (v) => !v || v !== getHiringManager(round, 0) || 'Role already selected in this round'
                              ]"
                              required>
                                <template v-slot:label>
                                  Secondary Hiring Manager<span class="required"> *</span>
                                </template>
                              </v-autocomplete>
                            </v-col>
                            <v-col v-if="Number(numberOfHiringManagersRoundWise[round]) > 2" class="py-0 my-0" cols="6">
                              <v-autocomplete
                              outlined
                              class="rounded-xl"
                              :value="getHiringManager(round, 2)"
                              @input="setHiringManager(round, 2, $event)"
                              :items="hiringManagerItemsForRound(round, [getHiringManager(round, 0), getHiringManager(round, 1)])"
                              :filter="customFilter"
                              no-data-text="No matching records found"
                              :menu.sync="menu"
                              :loading="loadingRoles['tertiaryHiringManagerHRISUniqueRolesRoundWise'][round]"
                              :hide-no-data="loadingRoles['tertiaryHiringManagerHRISUniqueRolesRoundWise'][round]"
                              :search-input.sync="tags['tertiaryHiringManagerHRISUniqueRolesRoundWise'][round]"
                              @focus="onAutocompleteInteraction('tertiaryHiringManagerHRISUniqueRolesRoundWise', round)"
                              item-text="hrisUniqueRole" item-value="hrisUniqueRole"
                              :rules="[
                                (v) => !!v || 'Tertiary Hiring Manager is required',
                                (v) => !v || (v !== getHiringManager(round, 0) && v !== getHiringManager(round, 1)) || 'Role already selected in this round'
                              ]"
                              required>
                                <template v-slot:label>
                                  Tertiary Hiring Manager<span class="required"> *</span>
                                </template>
                              </v-autocomplete>
                            </v-col>
                          </v-row>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-form>
                  <div class="d-flex justify-end gap-2 pa-4 ma-0 form-action-bar">
                     <v-btn rounded text class="btn outline-btn" @click="closeFormDialog" >
                        Cancel
                      </v-btn>
                      <v-btn rounded depressed :disabled="shouldDisableFormBtn"  @click="saveInputs" class="btn primary-btn" :loading="loading" >
                        {{ formActionType }}
                      </v-btn>
                    </div>
                </div>
                <v-form v-else-if="formActionType === 'View'">
                    <v-card id="myScroll" rounded flat class="view-form-card pa-0">
                      <v-card-text>
                        <v-row class="view-mode-text">
                          <v-col class="d-flex flex-column">
                            <div class="text-caption">
                              Department Group
                            </div>
                            <div class="text-body-2 font-weight-bold">
                              {{ departmentGroupName || '' }}
                            </div>
                          </v-col>
                          <v-col class="d-flex flex-column">
                            <div class="text-caption">
                              Department
                            </div>
                            <div class="text-body-2 font-weight-bold">
                              {{ department || ''}}
                            </div>
                          </v-col>
                        </v-row>

                        <v-row class="view-mode-text">
                          <v-col class="d-flex flex-column">
                            <div class="text-caption">
                              HRIS Unique Role
                            </div>
                            <div class="text-body-2 font-weight-bold">
                              {{ HRIS_unique_role || '' }}
                            </div>
                          </v-col>
                          <v-col class="d-flex flex-column">
                            <div class="text-caption">
                              Role
                            </div>
                            <div class="text-body-2 font-weight-bold">
                              {{ roles || ''}}
                            </div>
                          </v-col>
                        </v-row>

                        <v-row class="view-mode-text">
                          <v-col class="d-flex flex-column">
                            <div class="text-caption">
                              Level
                            </div>
                            <div class="text-body-2 font-weight-bold">
                              {{ level || '' }}
                            </div>
                          </v-col>
                          <v-col >
                            <div class="text-caption">
                              Campaign
                            </div>
                            <div class="text-body-2 font-weight-bold">
                              {{ campaignName || ''}}
                            </div>
                          </v-col>
                        </v-row>

                        <v-row class="d-flex justify-space-between align-center ma-0 pt-8">
                            <div class="d-flex form-title-text">
                              Select the stages applicable to this role
                            </div>
                            <div class="d-flex align-center gap-4">
                              <v-checkbox disabled label="Screening" class="disabled-checkbox" v-model="screeningRequired" dense hide-details></v-checkbox>
                              <v-checkbox disabled label="Mains" class="disabled-checkbox" v-model="mainsRequired" dense hide-details></v-checkbox>
                              <v-checkbox disabled label="Demo" class="disabled-checkbox" v-model="demoRequired" dense hide-details></v-checkbox>
                              <v-checkbox disabled label="Interview" class="disabled-checkbox" v-model="interviewRequired" dense hide-details></v-checkbox>
                            </div>
                        </v-row>

                        <v-row class="view-mode-text pt-0">
                          <v-col class="d-flex flex-column pt-0">
                            <div class="text-caption">
                              Interview Rounds
                            </div>
                            <div class="text-body-2 font-weight-bold">
                              {{ interviewRounds || 1 }}
                            </div>
                          </v-col>
                          <v-col class="d-flex flex-column pt-0">
                            <div class="text-caption">
                              Interviewer/Hiring Manager Scope
                            </div>
                            <div class="text-body-2 font-weight-bold">
                              {{ interviewerScope || '-' }}
                            </div>
                          </v-col>
                        </v-row>

                        <div v-for="(round) in interviewRoundsCards"
                        :key="`interviewRound${round}`" class="interview-rounds-card rounded-xl my-4 pa-4 d-flex flex-column gap-2">
                          <div class="form-title-text text-body-1"> Interview Round {{round}}</div>
                          <v-row class="view-mode-text d-flex justify-space-between">
                            <v-col class="d-flex flex-column gap-3">
                              <div class="text-caption">
                                Interviewer
                              </div>
                              <div class="text-body-2 font-weight-bold">
                                {{ interviewerHRISUniqueRolesRoundWise[round]?.join(', ') || '' }}
                              </div>
                            </v-col>
                            <v-col class="d-flex flex-column gap-3">
                              <div class="text-caption">
                                Slot Approver
                              </div>
                              <div class="text-body-2 font-weight-bold">
                                {{ slotApproverHRISUniqueRoleRoundWise[round] || '-' }}
                              </div>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col class="d-flex flex-column gap-3">
                              <div class="text-caption">
                                <div class="d-flex align-start">
                                  Number of Hiring Managers Roles
                                  <span class="pl-1">
                                    <InfoTooltip text="Assign Hiring Managers In The Order Of Priority. The Primary Hiring Manager Will Receive The Request First. If They Are Unavailable Or Do Not Take Action, The Request Can Be Handled By The Secondary Hiring Manager, Followed By The Tertiary Hiring Manager, And So On." />
                                  </span>
                                </div>
                              </div>
                              <div class="text-body-2 font-weight-bold">
                                {{ numberOfHiringManagersRoundWise[round] || '-' }}
                              </div>
                            </v-col>
                            <v-col cols="6" class="d-flex flex-column gap-3">
                              <div class="text-caption">
                                Primary Hiring Manager
                              </div>
                              <div class="text-body-2 font-weight-bold">
                                {{ getHiringManager(round, 0) || '-' }}
                              </div>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="6" v-if="getHiringManager(round, 1)" class="d-flex flex-column gap-3">
                              <div class="text-caption">
                                Secondary Hiring Manager
                              </div>
                              <div class="text-body-2 font-weight-bold">
                                {{ getHiringManager(round, 1) }}
                              </div>
                            </v-col>
                            <v-col cols="6" v-if="getHiringManager(round, 2)" class="d-flex flex-column gap-3">
                              <div class="text-caption">
                                Tertiary Hiring Manager
                              </div>
                              <div class="text-body-2 font-weight-bold">
                                {{ getHiringManager(round, 2) }}
                              </div>
                            </v-col>
                          </v-row>
                        </div>

                      </v-card-text>
                    </v-card>
                </v-form>
                
              </div>
            </v-row>
  
            <!-- Filter Dialog -->
            <v-dialog v-model="filterDialog" class="cdz" max-width="570px">
          <v-card width="570px" height="100vh" class="filterDialogClass">
            <v-row class="mt-4 mx-1">
              <v-col>
                <div class="pl-0 mb-2 text-body1 font-weight-bold grey--text">
                  Filter
                </div>
              </v-col>
              <v-col class="d-flex justify-end">
                <div @click="clearFilter" class="text-body1 font-weight-bold black--text cursor">
                  CLEAR FILTER
                </div>
              </v-col>
            </v-row>

            <v-tabs vertical>
              <div class="ml-3 mt-4 mr-4 filterLine">
                <v-tab class="black--text justify-start" active-class="activeTab">
                  <span>Department Group</span>
                  <span v-if="selectedDepartmentFilters.length > 0" class="ml-1">({{ selectedDepartmentFilters.length
                }})</span></v-tab>
                <v-tab class="black--text justify-start" active-class="activeTab">
                  <span>Level</span>
                  <span v-if="selectedLevelFilter.length > 0" class="ml-1">({{ selectedLevelFilter.length
                }})</span></v-tab>

              </div>

                <v-tab-item key="category">
            <v-card flat class="school-filter">
              <v-card-text>
                <v-chip-group v-model="selectedDepartmentFilters" active-class="active-chip" column :multiple="true">
                  <v-chip v-for="(value,department) in departmentFilterOptions" 
                  :key="department"
                  :value="department"
                  elevated>
                    {{department}}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item key="level">
            <v-card v-if="selectedDepartmentFilters.length <= 0" flat class="school-filter">
                <v-card-text class="d-flex justify-center">
                  Please Select Department First
                </v-card-text>
            </v-card>
            <v-card v-else flat class="school-filter">
              <v-card-text>
                <v-chip-group v-model="selectedLevelFilter" active-class="active-chip" column :multiple="true">
                  <v-chip v-for="(level,index) in levelOptions" 
                  :key="level"
                  :value="level"
                  elevated>
                    {{level}}
                  </v-chip>
                </v-chip-group>
              </v-card-text>
            </v-card>
          </v-tab-item>
            </v-tabs>

            <div class="filterDialogButton">
              <v-card-actions class="px-6 pb-3">
                <v-spacer></v-spacer>
                <v-btn rounded depressed class="btn outline-btn font-weight-medium pa-4"
                  @click="filterDialog = false">Cancel</v-btn>
                <v-btn rounded class="btn primary-btn pa-4" @click="
                  
                  (filterDialog = false),
                  filterAudienceRoles(),
                  getFilterCount()
                  ">Apply</v-btn>
              </v-card-actions>
            </div>
          </v-card>
        </v-dialog>

          </v-col>
        </v-row>
  
        <div v-if="!dialog">
          <v-row class="d-flex justify-center my-0 py-0">
            <v-col>
              <div class="text-h6">Role Mapping</div>
            </v-col>
  
            <v-col cols="10" class="pl-0 ml-0">
              <v-row justify="end" class="mb-1 mt-0">
                <v-text-field
                  solo
                  label="Search here..."
                  prepend-inner-icon="mdi-magnify"
                  v-model="search"
                  hide-details
                  class="search-bar border-button rounded-pill mx-3"
                  dense
                  clearable
                ></v-text-field>
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="btn outline-btn elevation-0 mx-2 pl-4 pr-6"
                  :class="filterCount > 0 ? 'outline-disabled-btn' : ''"
                  rounded
                  depressed
                  v-bind="attrs"
                  v-on="on"
                  :disabled="filterCount > 0"
                >
                <v-img
                v-bind="attrs" 
                v-on="on" 
                :style="filterCount > 0 ? 'filter: grayscale(100%) opacity(50%);' :''"
                :src="require(`@/assets/svg/sort.svg`)"
                />              
                  <span>SORT</span>
                </v-btn>
              </template>
              <v-list>
                <v-list-item 
                  v-for="option in sortOptions" 
                  :key="option.value" 
                  @click="selectSortOption(option.value)"
                  :class="{'selected-sort-option': selectedSort === option.value}"
                >
                  <v-list-item-title>
                    {{ option.label }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
                  <v-btn icon  depressed outlined rounded class="btn outline-btn download-btn-icon elevation-0 mx-3" @click="downloadRoles">
                    <v-icon>mdi-import mdi-rotate-90</v-icon>
                  </v-btn>

                  <v-btn class="btn  mx-3" v-if="$store.state.role?.hirsUniqeRole?.delete" :disabled="selected.length == 0" :class="selected.length?'btn outline-btn elevation-0':''" rounded outlined @click="deleteDialog = true">
                    <v-icon class="pr-2">mdi-trash-can-outline</v-icon>
                    <span>Delete</span>
                  </v-btn>

                  <v-btn @click="filterDialog = true" depressed outlined rounded class="btn outline-btn elevation-0  mx-3">
                    <v-icon class="pr-2">mdi-tune</v-icon>
                    <span v-if="filterCount > 0" >
                      Filter ({{ filterCount }})
                    </span>
                    <span v-else>Filter</span>
                  </v-btn>

                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-if="$store.state.role?.hirsUniqeRole?.create"
                    class="btn primary-btn mx-3 white--text"
                    rounded
                    v-bind="attrs"
                    v-on="on"
                    depressed
                    ><v-icon class="pr-2">mdi-plus</v-icon>Create</v-btn
                  >
                </template>
                  <v-list>
                    <v-list-item @click="createForm">
                      <v-list-item-title>
                        <v-icon class="pr-1">mdi-email-plus-outline</v-icon>CREATE
                        NEW HRIS UNIQUE ROLES
                      </v-list-item-title>
                    </v-list-item>
  
                    <v-list-item @click="openBulkUploadDialog">
                      <v-list-item-title>
                        <v-icon>mdi-account-multiple-plus </v-icon>
  
                        CREATE HRIS UNIQUE ROLE IN BULK
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-row>
            </v-col>
          </v-row>
          <v-data-table
            fixed-header
            height="calc(100vh - 230px)"
            class="rounded-table custom-data-table frozen-column-table"
            :class="{ 'has-actions': $store.state.role?.hirsUniqeRole?.update }"
            :search="search"
            v-model="selected"
            :loading="dataTableLoading"
            loading-text="Loading HRIS Unique Roles"
            :disable-sort="true"
            :headers="headers"
            :items="tableData"
            :items-per-page="dataTableOptions.itemsPerPage"
            show-select
            :single-select="singleSelect"
            :options.sync="dataTableOptions"
            :server-items-length="count"
            hide-default-footer
          >
          <template v-slot:loading>
            <bubble-loader/>
          </template>
          <template v-for="(round, index) in maxInterviewRounds" v-slot:[`header.interviewRound${index+1}Group`]="{ item }" >
            <div class="w-100 d-flex flex-column">
              <div class="d-flex pt-3 justify-center align-center text-no-wrap">Interview Round {{round}}</div>
              <div class="w-100 d-flex py-3 justify-space-between align-center text-no-wrap sub-header">
                  <div>Interviewer</div>
                  <div>{{round === maxInterviewRounds ? 'Hiring Manager' : 'Decision Maker'}}</div>
              </div>
            </div>
          </template>
            <template v-slot:no-data>
              <div class="custom-no-data">
                <p>No Data Available</p>
              </div>
            </template>
            <template v-slot:[`item.HRIS_unique_role`]="{ item }">
               <v-tooltip bottom >
                    <template v-slot:activator="{ on, attrs }">
                      <span class="widened-multi-line-ellipsis cursor" v-bind="attrs" v-on="on">  {{ item.HRIS_unique_role }} </span>
                    </template>
                    <span> {{ item.HRIS_unique_role }} </span>
                </v-tooltip>
            </template>
            <template v-slot:[`item.department`]="{ item }">
               <v-tooltip bottom >
                    <template v-slot:activator="{ on, attrs }">
                      <span class="widened-multi-line-ellipsis cursor" v-bind="attrs" v-on="on">  {{ item.department }} </span>
                    </template>
                    <span> {{ item.department }} </span>
                </v-tooltip>
            </template>
            <template v-slot:[`item.level`]="{ item }">
               <v-tooltip bottom >
                    <template v-slot:activator="{ on, attrs }">
                      <span class="widened-multi-line-ellipsis cursor" v-bind="attrs" v-on="on">  {{ item.level }} </span>
                    </template>
                    <span> {{ item.level }} </span>
                </v-tooltip>
            </template>

            <template v-slot:item.screeningRequired="{ item }">
              {{ item?.screeningRequired ? 'Yes' : 'No' }}
            </template>

            <template v-slot:item.mainsRequired="{ item }">
              {{ item?.mainsRequired ? 'Yes' : 'No' }}
            </template>

            <template v-slot:item.demoRequired="{ item }">
              {{ item?.demoRequired ? 'Yes' : 'No' }}
            </template>

            <template v-slot:item.interviewRounds="{ item }">
              <div class="d-flex justify-center align-center">
                <div>{{item?.interviewRounds}}</div>
              </div>
            </template>

            <template v-for="(round, index) in maxInterviewRounds" v-slot:[`item.interviewRound${index+1}Group`]="{ item }" >
              <div class="d-flex justify-space-between align-center w-100">
                <!-- Roundwise Interviewers -->
                <v-tooltip v-if="item?.interviewerHRISUniqueRolesRoundWise && item.interviewerHRISUniqueRolesRoundWise[round]?.length" bottom >
                  <template v-slot:activator="{ on, attrs }">
                    <div class="d-flex justify-start gap-1">
                      <span class="multi-line-ellipsis cursor" v-bind="attrs" v-on="on">  {{ item?.interviewerHRISUniqueRolesRoundWise[round][0]  }} </span>
                      <span v-if="item?.interviewerHRISUniqueRolesRoundWise[round]?.length > 1">+ {{ item?.interviewerHRISUniqueRolesRoundWise[round]?.length - 1 }}</span>
                    </div>
                  </template>
                  <template v-slot:default>
                    <div>
                      <div v-for="(interviewerHRISUniqueRole, index) in  item?.interviewerHRISUniqueRolesRoundWise[round]" :key="`${round}${interviewerHRISUniqueRole}${index}`">
                        {{ interviewerHRISUniqueRole }} 
                      </div>
                    </div>
                  </template>
                </v-tooltip>
                <div v-else class="d-flex justify-start align-center" style="min-width: 120px">
                  <div>NA</div>
                </div>

                <!-- Roundwise Decision/Hiring Managers -->
                <v-tooltip v-if="item?.hiringManagerHRISUniqueRolesRoundWise && item.hiringManagerHRISUniqueRolesRoundWise[round]?.length" bottom >
                    <template v-slot:activator="{ on, attrs }">
                      <div class="d-flex justify-end gap-1">
                        <span class="multi-line-ellipsis cursor" v-bind="attrs" v-on="on">  {{ item?.hiringManagerHRISUniqueRolesRoundWise[round][0]  }} </span>
                        <span v-if="item?.hiringManagerHRISUniqueRolesRoundWise[round].length > 1">+{{ item?.hiringManagerHRISUniqueRolesRoundWise[round]?.length - 1 }}</span>
                      </div>
                    </template>
                    <template v-slot:default>
                      <div>
                        <div v-for="(hiringManagerHRISUniqueRole, index) in item?.hiringManagerHRISUniqueRolesRoundWise[round]" :key="`${round}${hiringManagerHRISUniqueRole}${index}`">
                          {{ hiringManagerHRISUniqueRole }} 
                        </div>
                      </div>
                    </template>
                </v-tooltip>
                <div v-else class="d-flex justify-start align-center" style="min-width: 120px">
                  <div>NA</div>
                </div>
              </div>
            </template>

            <template v-slot:[`item.actions`]="{ item }">
              <div class="d-flex align-center justify-center">
                <v-btn v-if="$store.state.role?.hirsUniqeRole?.update"
                  icon
                  class="pa-0"
                  @click="openActionDialog(item, 'Update')"
                >
                  <img
                    width="36px"
                    class="cursor"
                    src="../../assets/edit.svg"
                  />
                </v-btn>
                <v-btn v-if="$store.state.role?.hirsUniqeRole?.read"
                  icon
                  class="pa-0"
                  @click="openActionDialog(item, 'View')"
                >
                  <img
                    width="28px"
                    class="cursor"
                    src="../../assets/view.svg"
                  />
                </v-btn>
              </div>
            </template>
            <template v-slot:no-results>
              <div class="mt-16 pt-16">
                <img 
                src="../../assets/noResultFound.svg"/>
              </div>
            </template>
            <template v-slot:footer="{ props }">
              <table-footer
                :pagination="props.pagination"
                :options="props.options"
                @update-options="onFooterUpdate"
              />
            </template>
          </v-data-table>
        </div>
  
        <v-dialog v-model="deleteDialog" class="cdz" max-width="400px" persistent>
          <v-card fluid>
            <v-container fluid class="pa-0">
              <v-card-text class="d-flex flex-column gap-4">
                <p class="text-h6 card-title-text">Delete</p>
                <p class="text-subtitle-1" color="#666666" disabled>
                  Are you sure you want to delete this item? This action cannot be undone.
                </p>
                  <div class="d-flex justify-end gap-2 mt-2" fluid>
                  <v-btn depressed class="btn outline-btn" large rounded @click="deleteDialog = false" >
                    CANCEL
                  </v-btn>
                  <v-btn class="btn primary-btn" depressed large rounded :loading="dLoading" @click="deleteData(selected)">
                    DELETE
                  </v-btn>
                </div>
              </v-card-text>
            </v-container>
          </v-card>
        </v-dialog>
  
        <v-dialog v-model="errorDialog" class="cdz" max-width="366px" persistent>
          <v-card>
            <v-container fluid class="pa-8">
              <v-card-text class="text-center">
                <v-icon color="error" size="96">mdi-close-circle-outline</v-icon>
                <p class="text-h5 pt-2 font-weight-medium">Error</p>
                <p class="text-h6 py-3 font-weight-regular">{{ errorMessage }}</p>
                <div class="d-flex justify-center">
                     <v-btn
                  class="primary-btn btn"
                  large
                  width="157px"
                  rounded
                  @click="errorDialog = false"
                  >Ok</v-btn
                >
                </div>
              </v-card-text>
            </v-container>
          </v-card>
        </v-dialog>


        <v-dialog v-model="deleteSuccessDialog" class="cdz" max-width="300px" persistent >
          <v-card>
            <v-container fluid class="pa-4">
              <v-card-text class="d-flex flex-column justify-center gap-4">
                <div class="d-flex justify-center">
                  <img :width="100" :height="100" :src="require('../../assets/delete-icon.svg')" alt="Download Icon"/>
                </div>
                <p class="text-h6 text-center font-weight-bold">Role Mapping Deleted Successfully</p>
                <div class="d-flex justify-center">
                  <v-btn class="btn primary-btn" large width="157px" rounded @click="deleteSuccessDialog = false" >
                    Ok
                  </v-btn>
                </div>
              </v-card-text>
            </v-container>
          </v-card>
        </v-dialog>
        <v-dialog
          v-model="successDialog"
          class="cdz"
          max-width="366px"
          persistent
        >
          <v-card>
            <v-container fluid class="pa-8">
              <v-card-text class="text-center">
                <v-icon color="#228B22" size="96"
                  >mdi-check-circle-outline</v-icon
                >
                <p class="text-h5 py-4">Role Mapping {{ formActionType + 'd' }} Successfully</p>
                <div class="d-flex justify-center">
                             <v-btn
                  class="btn primary-btn"
                  large
                  width="157px"
                  rounded
                  @click="successDialog = false"
                  >Ok</v-btn
                >
                </div>
              </v-card-text>
            </v-container>
          </v-card>
        </v-dialog>
      </div>
  
      <!-- Notification Dialog -->
      <v-dialog v-model="notificationDialog" class="cdz" max-width="380px">
        <Notification @close-dialog="notificationDialog = false" />
      </v-dialog>
    </div>
  </template>
  <script>
  import { debounce, cloneDeep } from 'lodash';
  import axios from "axios";
  import AuthService from "../../services/AuthService";
  import AudienceRolesController from "@/controllers/AudienceRolesController";
  import CampaignController from "@/controllers/CampaignController";
  import LevelController from "@/controllers/LevelController";
  import Papa from "papaparse";
  import * as XLSX from 'xlsx';
  import Notification from "../Notification.vue";
  import MastersDropdownComponent from "@/components/MastersDropdownComponent.vue";
  import { collection, getDocs, query, where } from "firebase/firestore";
  import UserNavMenu from "@/components/UserNavMenu.vue";
  
  import { db } from "../../firebase";
  import BubbleLoader from '@/components/BubbleLoader.vue';
  import InfoTooltip from "@/components/InfoTooltip.vue";
  import isTableScrollableMixin from "@/mixins/isTableScrollableMixin";

  export default {
    name: "AudienceRolesView",
    mixins: [  isTableScrollableMixin ],
    components: {
      Notification, MastersDropdownComponent, BubbleLoader,UserNavMenu, InfoTooltip
    },
  
    data() {
      return {
        filterCount: 0,
        debouncedSearch: null,
        removedRows: [],
        
        uploadBulkAudienceRoles: false,
        notificationDialog: false,
        appliedFilter: false,
        dataTableOptions: { page: 1, itemsPerPage: 10 },
        unsubscribe: [],
        bulkAudienceRolesJsonData: [],
        bulkAudienceRolesResponse: [],
        headersresponce: [
          { text: "Index in CSV", value: "audienceRolesIndex" },
          { text: "Status", value: "status" },
        ],
        dataTableLoading: false,
        page: 1,
        count: 0,
        errorDialog: false,
        successDialog: false,
        deleteSuccessDialog: false,
        dialog: false,
        errorMessage: "",
        deleteDialog: false,
        audienceRolesData: "",
        dLoading: false,
        singleSelect: false,
        isFilterLoading: false,
        selected: [],
        levels: [],
        levelsMaster: [],
        clusterData: [],
        filterDialog: false,
        formActionType: 'View',
        loading: false,
        HRIS_unique_role: "",
        HRIS_unique_role_code: "",
        viewAudienceRolesDialog: false,
        countryName: "India",
        filterData: false,
        department: "",
        campaignId: "",
        interviewerScope: "",
        selectedLevelFilter: [],
        selectedDepartmentFilters: [],
        sortCol:"HRIS_unique_role",
        sortOrder: "asc", // Default sort order (asc or desc)
        selectedSort: "HRISAsc", // Default selected sort option
        sortOptions: [
        { value: "HRISAsc", label: "HRIS Role Name - Ascending (A-Z)" },
        { value: "HRISDesc", label: "HRIS Role Name - Descending (Z-A)" },
        { value: "dateNewest", label: "Date - Newest" },
        { value: "dateOldest", label: "Date - Oldest" },
      ],
        headers: [
          { text: "HRIS Unique Role", value: "HRIS_unique_role", class: "elipsis", width: '272px' },
          { text: "Department", value: "department", class: "elipsis",  width: '180px' },
          { text: "Level", value: "level", class: "elipsis" },
          { text: "Screening Required", value: "screeningRequired", class: "elipsis" },
          { text: "Mains Required", value: "mainsRequired", class: "elipsis" },
          { text: "Demo Required", value: "demoRequired", class: "elipsis" },
          { text: "Interview Rounds", value: "interviewRounds", class: "elipsis" },
          { text: "Interview Round 1", value: "interviewRound1Group", cellClass: "grouped-col", class: "grouped-col"},
          { text: "Interview Round 2", value: "interviewRound2Group", cellClass: "grouped-col", class: "grouped-col"},
          { text: "Interview Round 3", value: "interviewRound3Group", cellClass: "grouped-col", class: "grouped-col"},
          { text: "Interview Round 4", value: "interviewRound4Group", cellClass: "grouped-col", class: "grouped-col"},
          { text: "Interview Round 5", value: "interviewRound5Group", cellClass: "last-grouped-col", class: "last-grouped-col"},
          { text: "Actions", value: "actions", class: "elipsis actions-column", cellClass: 'actions-column', },
        ],
        maxInterviewRounds : 5,
        interviewRoleSelectionLimit: 7,
        tableData: [],
        search: "",
        searchBool: false,
        rules: {
          required: (value) => !!value || "Field is required",
        },
        department_group:"",
        level:"",
        roles:"",
        audience_role:"",
        audienceRoleGroups:[],
        screeningRequired: false,
        mainsRequired: false,
        demoRequired: false,
        interviewRequired: true,
        interviewRounds: 1,
        interviewerHRISUniqueRolesRoundWise: {},
        slotApproverHRISUniqueRoleRoundWise: {},
        numberOfHiringManagersRoundWise: { 1: 1 },
        hiringManagerHRISUniqueRolesRoundWise: {},
        mandatoryCsvFields: [
          ["srNo", "Sr No."],
          ["departmentGroup", "Department Group*"],
          ["department", "Department*"],
          ["hrisRole", "HRIS Unique Role*"],
          ["level", "Level*"],
          ["campaignId", "Campaign Id*"],
          ["scope", "Interviewer/Hiring Manager Scope*"],
          ["screening", "Screening Required (Yes/ No)*"],
          ["mains", "Mains Required (Yes/ No)*"],
          ["demo", "Demo Required (Yes/ No)*"],
          ["rounds", "Interview Rounds*"],
        ],
        csvHeaderMap: { base: {}, rounds: {} },
        mdmRoleMap: {},
        departmentsFromMDM: [],
        fileName: '',
        showConfirmDialog: false,
        uploadingRolesDialog: false,
        uploadingAudienceRoles: false,
        failedRows: [],
        failedRowCount: 0,
        successfullRowCount: 0,
        campaignsList: [],
        interviewerScopeList: ["Vertex", "School", "Cluster"],
        departmentsList: [],
        audienceRolesList: [],        // Roles for interviewer + hiring manager rounds
        hrisUniqueRolesList: [],      // Roles for HRIS Unique Role field (department-filtered)
        selectedRoles: [],            // v-model for the autocomplete (array of values)
        storedRoles: [],

        currentPage: 1,               // Page index for audienceRolesList (rounds)
        hrisUniqueRolesPage: 1,       // Page index for hrisUniqueRolesList
        pageSize: 20,                 // Items per page (depends on backend)
        hasMoreData: true,            // Whether more rounds pages exist
        hrisUniqueRolesHasMore: true, // Whether more HRIS pages exist
        menu: false,
        activeAutoCompleteId: '',
        activeAutoCompleteRound: 0,
        activeRound: 0,
        roundWiseSearchFieldIds: [
          'interviewerHRISUniqueRolesRoundWise',
          'slotApproverHRISUniqueRoleRoundWise',
          'primaryHiringManagerHRISUniqueRolesRoundWise',
          'secondaryHiringManagerHRISUniqueRolesRoundWise',
          'tertiaryHiringManagerHRISUniqueRolesRoundWise',
        ],
        roundWiseRoleModelIds: [
          'interviewerHRISUniqueRolesRoundWise',
          'slotApproverHRISUniqueRoleRoundWise',
          'hiringManagerHRISUniqueRolesRoundWise',
        ],
        loadingRoles: {
          hrisUniqueRole: false,
          interviewerHRISUniqueRolesRoundWise: {},
          slotApproverHRISUniqueRoleRoundWise: {},
          primaryHiringManagerHRISUniqueRolesRoundWise: {},
          secondaryHiringManagerHRISUniqueRolesRoundWise: {},
          tertiaryHiringManagerHRISUniqueRolesRoundWise: {},
        },                            // Loader for API call
        rolesScrollObserver: null,    // IntersectionObserver instance
        mutationObserver: null,       // MutationObserver instance
        menuContent: null,            // menu item to be observed
        scrollPending: false,
        observedElements: new Set(),  // To avoid repeated triggering per element
        lastWatchedIndex: null,       // Track which element was last seen
        tags: {
          hrisUniqueRole: '',
          interviewerHRISUniqueRolesRoundWise: {},
          slotApproverHRISUniqueRoleRoundWise: {},
          primaryHiringManagerHRISUniqueRolesRoundWise: {},
          secondaryHiringManagerHRISUniqueRolesRoundWise: {},
          tertiaryHiringManagerHRISUniqueRolesRoundWise: {}
        },
        unwatchTags: [],
        tagsDebouncer: {
          hrisUniqueRole: '',
          interviewerHRISUniqueRolesRoundWise: {},
          slotApproverHRISUniqueRoleRoundWise: {},
          primaryHiringManagerHRISUniqueRolesRoundWise: {},
          secondaryHiringManagerHRISUniqueRolesRoundWise: {},
          tertiaryHiringManagerHRISUniqueRolesRoundWise: {}
        },
        formHash: '',
        isInitializingForm: false,
        departmentOptions:[],
        levelOptions:[],
      };
    },
    
    created() {
      const urlSearch = this.$route.query.search;
      if (urlSearch) {
        this.search = urlSearch;
      }      
      this.getLevels();
      if (!this.$store.state.role.school.read) {
        this.$router.push("/notFound");
      }
      this.debouncedSearch = debounce(this.getAudienceRoles, 500);
      this.$store.state.breadcrumb = "HRIS Unique Roles";
    },
    mounted(){
      this.getAudienceRoles();
      this.getAudienceRoleGroups();
      this.getDepartmentsFromMDM();
      this.getCampaigns();
      this.initMutationObserver();
      this.initDynamicTags();
      this.getMasterFilters();
    },
    unmounted() {
    this.debouncedSearch.cancel();
  },
    computed: {
      selectedItemsRequired() {
              return (v) => (v && v.length > 0) || 'Boards is required';
          },
      departmentFilterKeys() {
        return Object.keys(this.departmentFilterOptions);
      },
      selectedAudienceRoleGroupIds() {
        return this.selectedDepartmentFilters
          .filter((department) => department !== 'All')
          .map((department) => this.audienceRoleGroups.find(({ name }) => name === department)?.id)
          .filter(Boolean);
      },
      departmentFilterOptions() {
        const allLevels = Array.from(
          new Set(
            Object.values(this.departmentOptions || {}).flatMap((levels) =>
              Array.isArray(levels) ? levels : []
            )
          )
        );

        return {
          All: allLevels,
          ...this.departmentOptions,
        };
      },
      interviewRoundsCards(){
        return Math.min(Number(this.interviewRounds), this.maxInterviewRounds)
      },
      roundWiseAudienceRoleItems() {
        const itemsByRound = {};
        const rounds = Number(this.interviewRoundsCards) || 0;

        for (let round = 1; round <= rounds; round++) {
          const selectedRoles = [];
          this.roundWiseRoleModelIds.forEach(fieldId => {
            const val = this[fieldId][round];
            if (Array.isArray(val)) selectedRoles.push(...val);
            else if (val) selectedRoles.push(val);
          });

          const selectedItems = selectedRoles.filter(Boolean).map(role => ({ hrisUniqueRole: role, role: '' }));
          itemsByRound[round] = this.mergeAudienceRoleItems(selectedItems, this.audienceRolesList);
        }

        return itemsByRound;
      },
      departmentGroupName() {
        return this.audienceRoleGroups.find(({ id }) => id === this.department_group)?.name || '';
      },
      campaignName() {
        return this.campaignsList.find(({ id }) => id === this.campaignId)?.name || '';
      },
      shouldDisableFormBtn() {
        const formType = this.formActionType;
        if (formType !== 'Create' && formType !== 'Update') return true;

        const numRounds = Number(this.interviewRoundsCards) || 0;
        const rounds = Array.from({ length: numRounds }, (_, i) => i + 1);

        const everyRoundValid = rounds.length > 0 && rounds.every(round => {
          const hasInterviewers = this.interviewerHRISUniqueRolesRoundWise[round]?.length > 0;
          const hasSlotApprover = !!this.slotApproverHRISUniqueRoleRoundWise[round];
          const hiringManagersCount = Number(this.numberOfHiringManagersRoundWise[round]);
          const hiringManagers = this.visibleHiringManagersForRound(round);
          const allHiringManagersSelected = hiringManagers.every(Boolean);
          const noDuplicateHiringManagers = new Set(hiringManagers.filter(Boolean)).size === hiringManagers.filter(Boolean).length;

          return hasInterviewers &&
            hasSlotApprover &&
            [1, 2, 3].includes(hiringManagersCount) &&
            allHiringManagersSelected &&
            noDuplicateHiringManagers;
        });

        const isFormValid =
          !!this.HRIS_unique_role &&
          !!this.department_group &&
          !!this.department &&
          !!this.campaignId &&
          !!this.level &&
          !!this.HRIS_unique_role_code &&
          !!this.roles &&
          !!this.interviewerScope &&
          everyRoundValid;

        if (formType === 'Create') return !isFormValid;

        // Update: additionally require an actual change
        const hasChanges = this.getFormHash() !== this.formHash;
        return !(isFormValid && hasChanges);
      },
    },
    watch: {
      interviewRounds(newVal) {
        this.handleInterviewRoundsChange(newVal);
      },
      selectedDepartmentFilters(newVal, oldVal = []) {
        const hasAll = newVal?.includes('All');
        const hadAll = oldVal?.includes('All');
        const allKeys = this.departmentFilterKeys;
        const individualKeys = allKeys.filter((key) => key !== 'All');

        if (hasAll && !hadAll) {
          this.selectedDepartmentFilters = allKeys;
          return;
        }

        if (hadAll && !hasAll && oldVal.length === allKeys.length) {
          this.selectedDepartmentFilters = [];
          return;
        }

        if (hadAll && hasAll && newVal.length < allKeys.length) {
          this.selectedDepartmentFilters = newVal.filter((key) => key !== 'All');
          return;
        }

        if (!hasAll && newVal.length === individualKeys.length && individualKeys.length > 0) {
          this.selectedDepartmentFilters = allKeys;
          return;
        }

        if (!newVal || newVal.length === 0) {
          this.levelOptions = [];
          return;
        }

        const levels = new Set();

        newVal.forEach(cat => {
          const details = this.departmentFilterOptions[cat];

          if (details && Array.isArray(details)) {
            details.forEach(l => levels.add(l));
          }
        });

        this.levelOptions = Array.from(levels);

      },
      search(newValue) {
        this.$router.replace({ 
        query: { 
          ...this.$route.query,
          search: newValue || undefined 
        }
        }).catch(() => {});
        if (newValue === null)
          this.search = ""
          this.dataTableOptions.page = 1
        this.debouncedSearch();
      },
      'tags.hrisUniqueRole'(newVal, oldVal) {
          if (this.isInitializingForm) return;
          const prev = oldVal || '';
          const curr = newVal || '';
          if(!prev && !curr )  return;
          if((prev !== curr) && this.activeAutoCompleteId === 'hrisUniqueRole')
            this.debouncedTagsChange('hrisUniqueRole');
      }
    },
    methods: {
      async onFooterUpdate(newOptions) {
        this.dataTableOptions = { ...this.dataTableOptions, ...newOptions };
        await this.$nextTick();
        await this.getAudienceRoles();
      },
      async getMasterFilters() {
      const docId = 'audienceRoles';
        try {
          
            const response = await AudienceRolesController.getMasterFilters(docId);
            
            // this.timerTypeOptions = response.data.departmentGroupLevelMap;
            this.departmentOptions = response.data.departmentGroupLevelMap;

          
        } catch (error) {
            return error.response;
        }
    },
      
      async getLevels() {
        const response = await LevelController.getLevel();
        this.levelsMaster = response?.data?.levels || [];
      },
      getFormHash(currentForm = false) {
        const form = cloneDeep(currentForm) || this;

        const parts = [];

        const departmentGroupId = this.audienceRoleGroups.find(({ id, name }) => id === form.department_group || name === form.department_group)?.id || '';

        const campaignId = form.campaignId || '';

        // Basic fields
        parts.push(
          form.HRIS_unique_role || '',
          form.HRIS_unique_role_code || '',
          departmentGroupId  || '',
          form.department || '',
          campaignId || '',
          form.level || '',
          form.interviewRounds || '',
          form.roles || '',
          form.interviewerScope || ''
        );

        // Required booleans
        parts.push(
          form.screeningRequired ? '1' : '0',
          form.mainsRequired ? '1' : '0',
          form.demoRequired ? '1' : '0'
        );

        // Interviewers hash (convert arrays to single strings)
        Object.entries(form.interviewerHRISUniqueRolesRoundWise || {}).forEach(
          ([key, val]) => {
            const str = Array.isArray(val) ? val?.join() : val || '';
            parts.push(`I-${key}:${str}`);
          }
        );

        // Slot approver hash
        Object.entries(form.slotApproverHRISUniqueRoleRoundWise || {}).forEach(([key, val]) => {
          const str = Array.isArray(val) ? (val[0] || '') : val || '';
          parts.push(`S-${key}:${str}`);
        });

        // Hiring managers hash ({ round: [primary, secondary, tertiary] })
        Object.entries(form.hiringManagerHRISUniqueRolesRoundWise || {}).forEach(([key, val]) => {
          const str = Array.isArray(val) ? val.join() : val || '';
          parts.push(`H-${key}:${str}`);
        });

        return parts.join('|');
      },
      closeFormDialog(){
        this.dialog = false;
        this.clearFormStates();
      },
      clearFormStates(){
        this.HRIS_unique_role = '';
        this.department_group = '';
        this.department = '';
        this.campaignId = '';
        this.HRIS_unique_role_code = '';
        this.roles = ''
        this.level = '';
        this.screeningRequired = false;
        this.mainsRequired = false;
        this.demoRequired = false;
        this.interviewRounds = 1;
        this.interviewerHRISUniqueRolesRoundWise = {};
        this.hiringManagerHRISUniqueRolesRoundWise = {};
        this.interviewerScope = '';
        this.slotApproverHRISUniqueRoleRoundWise = {};
        this.numberOfHiringManagersRoundWise = { 1: 1 };
      },
      downloadTextFile(text, filename) {
        let element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
        element.setAttribute('download', filename);
  
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);
      },
      selectSortOption(sortOption) {
      this.selectedSort = sortOption;
      switch (sortOption) {
        case "HRISAsc":
          this.sortCol = "HRIS_unique_role";
          this.sortOrder = "asc";
          break;
        case "HRISDesc":
          this.sortCol = "HRIS_unique_role";
          this.sortOrder = "desc";
          break;
        case "dateNewest":
          this.sortCol = "createdOn";
          this.sortOrder = "desc";
          break;
        case "dateOldest":
          this.sortCol = "createdOn";
          this.sortOrder = "asc";
          break;
        default:
          this.selectedSort = "HRISAsc";
          this.sortCol = "HRIS_unique_role";
          this.sortOrder = "asc";
      }
      this.dataTableOptions.page = 1;
      this.getAudienceRoles();
    },
  
  
      uploadAudienceRoles() {
      return new Promise(async (resolve, reject) => {
        this.uploadingAudienceRoles = true;
        this.uploadBulkAudienceRoles = false;
  
        let index = 2;
        const uploadPromises = this.bulkAudienceRolesJsonData.map(async (audienceRoles_) => {
          try {
            const response = await AudienceRolesController.createAudienceRoles(audienceRoles_);
            if (response.status == 200) {
              this.bulkAudienceRolesResponse.push({
                audienceRolesIndex: index,
                status: "Uploaded Successfully!",
              });
            } else {
              this.bulkAudienceRolesResponse.push({
                audienceRolesIndex: index,
                status: "Uploaded Failed!",
              });
            }
            index++;
          } catch (error) {
            this.bulkAudienceRolesResponse.push({
              audienceRolesIndex: index,
              status: "Upload Failed due to error!",
            });
            index++;
          }
        });
  
        try {
          await Promise.all(uploadPromises);
          this.uploadingAudienceRoles = false;
          this.uploadingRolesDialog = false;
          this.showConfirmDialog = true;
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    },

    openBulkUploadDialog(){
      this.uploadBulkAudienceRoles = true;
      this.failedRows = [];
      this.bulkAudienceRolesJsonData = [];
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.processCSV(file);
      }
    },
    logFailedRow(rowIndex, reason, rowData = {}) {
      const clone = JSON.parse(JSON.stringify(rowData)); // deep clean
      this.failedRows.push({
        ...clone,
        Reason: reason,
        "Row Number": rowIndex + 1
      });
    },
    // Resolve actual CSV headers to canonical keys, tolerant of case and
    // trailing asterisks, so minor template wording changes don't break import.
    resolveCsvHeaderMap(headers) {
      const basePatterns = {
        srNo: /^Sr\.?\s*No\.?\s*\*?$/i,
        departmentGroup: /^Department\s+Group\s*\*?$/i,
        department: /^Department\s*\*?$/i,
        hrisRole: /^HRIS\s+Unique\s+Role\s*\*?$/i,
        hrisCode: /^HRIS\s+Unique\s+(?:Role\s+)?Code\s*\*?$/i,
        role: /^Role\s*\*?$/i,
        level: /^Level\s*\*?$/i,
        campaignId: /^Campaign\s*(?:Id|ID)\s*\*?$/i,
        scope: /^Interviewer\s*\/\s*Hiring\s+Manager\s+Scope\s*\*?$/i,
        screening: /^Screening\s+Required/i,
        mains: /^Mains\s+Required/i,
        demo: /^Demo\s+Required/i,
        rounds: /^(?:No\.?\s+of\s+)?Interview\s+Rounds\s*\*?$/i,
      };
      const roundPatterns = {
        interviewer: /^Round\s+(\d+)\s+Interviewer\s+HRIS\s+Unique\s+Role\s*\*?$/i,
        slotApprover: /^Round\s+(\d+)\s+Slot\s+Approver(?:\s+HRIS\s+Unique\s+Role)?\s*\*?$/i,
        hmCount: /^Round\s+(\d+)\s+(?:Number|No\.?)\s+of\s+Hiring\s+Managers\s*\*?$/i,
        primary: /^Round\s+(\d+)\s+Primary\s+Hiring\s+Manager\s*\*?$/i,
        secondary: /^Round\s+(\d+)\s+Secondary\s+Hiring\s+Manager\s*\*?$/i,
        tertiary: /^Round\s+(\d+)\s+Tertiary\s+Hiring\s+Manager\s*\*?$/i,
        legacyManager: /^Round\s+(\d+)\s+Decision\s+Maker\s*\/\s*Hiring\s+Manager\s*\*?$/i,
      };

      // The count column may appear as a bare "Number of Hiring Managers" repeated
      // per round block (no "Round N" prefix) — it belongs to the round of the
      // last round-prefixed column seen before it. A "(n)" suffix is tolerated
      // because duplicate headers get de-duplicated that way during parsing.
      const bareCountPattern = /^(?:Number|No\.?)\s+of\s+Hiring\s+Managers(?:\s*\(\d+\))?\s*\*?$/i;

      const base = {};
      const rounds = {};
      let contextRound = 0;
      headers.forEach(header => {
        const trimmed = (header || '').trim();
        for (const [key, pattern] of Object.entries(basePatterns)) {
          if (!base[key] && pattern.test(trimmed)) {
            base[key] = header;
            return;
          }
        }
        for (const [key, pattern] of Object.entries(roundPatterns)) {
          const match = trimmed.match(pattern);
          if (match) {
            const round = Number(match[1]);
            if (!rounds[round]) rounds[round] = {};
            rounds[round][key] = header;
            contextRound = round;
            return;
          }
        }
        if (bareCountPattern.test(trimmed) && contextRound) {
          if (!rounds[contextRound]) rounds[contextRound] = {};
          if (!rounds[contextRound].hmCount) rounds[contextRound].hmCount = header;
        }
      });
      return { base, rounds };
    },
    csvCellValue(row, header) {
      const value = header ? row[header] : undefined;
      return typeof value === 'string' ? value.trim() : (value ?? '');
    },
    // A cell counts as filled only if non-empty and not the export placeholder 'NA'
    isCsvCellFilled(row, header) {
      const value = this.csvCellValue(row, header);
      return value !== '' && String(value).toUpperCase() !== 'NA';
    },
    splitCsvRoles(cell) {
      return String(cell || '')
        .split(',')
        .map(part => part.trim())
        .filter(part => part && part.toUpperCase() !== 'NA');
    },
    validateMandatoryFields(row, rowIndex, headerMap) {
      for (const [key, label] of this.mandatoryCsvFields) {
        if (!this.checkMatters(row[headerMap.base[key]])) {
          this.logFailedRow(rowIndex, `${label} is mandatory`, row);
          return false;
        }
      }
      return true;
    },
    // Sr No. must be strictly serial (1, 2, 3, ...) — one row per role mapping.
    validateSerialNumbers(rows, headerMap) {
      const header = headerMap.base.srNo;
      let valid = true;
      rows.forEach((row, index) => {
        const raw = this.csvCellValue(row, header);
        if (!/^\d+$/.test(String(raw))) {
          this.logFailedRow(index + 1, `Sr No. "${raw}" must be a number`, row);
          valid = false;
          return;
        }
        if (Number(raw) !== index + 1) {
          this.logFailedRow(index + 1, `Sr No. must be serial: expected ${index + 1} but found ${Number(raw)}`, row);
          valid = false;
        }
      });
      return valid;
    },
    validateRowEnums(row, rowIndex, headerMap) {
      const { base, rounds } = headerMap;
      let isValid = true;
      const fail = reason => {
        this.logFailedRow(rowIndex, reason, row);
        isValid = false;
      };

      // Department Group — must match backend group nomenclature
      const groupNames = (this.audienceRoleGroups || []).map(({ name }) => name).filter(Boolean);
      const allowedGroups = groupNames.length ? groupNames : ['Academic', 'Non-Academic', 'Academic Support'];
      const group = this.csvCellValue(row, base.departmentGroup);
      const matchedGroup = allowedGroups.find(name => name.toLowerCase() === String(group).toLowerCase());
      if (!matchedGroup) fail(`Department Group* "${group}" is invalid. Allowed: ${allowedGroups.join(', ')}`);

      // Department — must exist in MDM and belong to the given group
      const department = this.csvCellValue(row, base.department);
      const departmentRecord = (this.departmentsFromMDM || []).find(
        record => String(record?.department || '').trim().toLowerCase() === String(department).toLowerCase()
      );
      if (!departmentRecord) fail(`Department* "${department}" not found in MDM`);
      else if (matchedGroup) {
        const departmentGroupOfDept =
          departmentRecord.departmentGroup ?? departmentRecord.department_group ?? departmentRecord.departmentGroupName ?? departmentRecord.group;
        if (departmentGroupOfDept && String(departmentGroupOfDept).trim().toLowerCase() !== matchedGroup.toLowerCase())
          fail(`Department* "${department}" does not belong to Department Group "${matchedGroup}"`);
      }

      const groupId = this.audienceRoleGroups.find(({ name }) => name === matchedGroup)?.id;
      const allowedLevels = this.levelsMaster
        .filter(({ audienceRoleGroupId }) => !groupId || audienceRoleGroupId === groupId)
        .map(({ name }) => name);
      const level = this.csvCellValue(row, base.level);
      if (allowedLevels.length && !allowedLevels.some(name => name.toLowerCase() === String(level).toLowerCase()))
        fail(`Level* "${level}" is invalid. Allowed: ${allowedLevels.join(', ')}`);

      const campaignId = this.csvCellValue(row, base.campaignId);
      if (!(this.campaignsList || []).some(({ id }) => String(id) === String(campaignId)))
        fail(`Campaign Id* "${campaignId}" is not a valid live campaign id`);

      // Interviewer/Hiring Manager Scope — fixed set
      const scope = this.csvCellValue(row, base.scope);
      if (!this.interviewerScopeList.some(name => name.toLowerCase() === String(scope).toLowerCase()))
        fail(`Interviewer/Hiring Manager Scope* "${scope}" is invalid. Allowed: ${this.interviewerScopeList.join(', ')}`);

      // Yes/No stage flags
      [
        [base.screening, 'Screening Required (Yes/ No)*'],
        [base.mains, 'Mains Required (Yes/ No)*'],
        [base.demo, 'Demo Required (Yes/ No)*'],
      ].forEach(([header, label]) => {
        const value = this.csvCellValue(row, header);
        if (!/^(yes|no)$/i.test(String(value))) fail(`${label} must be "Yes" or "No" (found "${value}")`);
      });

      // Interview Rounds — whole number within limits
      const roundsValue = this.csvCellValue(row, base.rounds);
      if (!/^\d+$/.test(String(roundsValue)) || Number(roundsValue) < 1 || Number(roundsValue) > this.maxInterviewRounds) {
        fail(`Interview Rounds* must be a whole number between 1 and ${this.maxInterviewRounds} (found "${roundsValue}")`);
        return isValid;
      }

      // Round-wise checks
      const totalRounds = Number(roundsValue);
      const tierLabels = { primary: 'Primary', secondary: 'Secondary', tertiary: 'Tertiary' };
      for (let r = 1; r <= totalRounds; r++) {
        const roundHeaders = rounds[r] || {};

        // Number of Hiring Managers — numeric 1..3, tiers must agree with it
        if (roundHeaders.hmCount && this.isCsvCellFilled(row, roundHeaders.hmCount)) {
          const count = this.csvCellValue(row, roundHeaders.hmCount);
          if (!/^\d+$/.test(String(count)) || Number(count) < 1 || Number(count) > 3) {
            fail(`Round ${r} Number of Hiring Managers must be a whole number between 1 and 3 (found "${count}")`);
          } else {
            ['primary', 'secondary', 'tertiary'].forEach((tier, tierIndex) => {
              if (!roundHeaders[tier]) return;
              const filled = this.isCsvCellFilled(row, roundHeaders[tier]);
              if (tierIndex < Number(count) && !filled)
                fail(`Round ${r} ${tierLabels[tier]} Hiring Manager is required when Number of Hiring Managers is ${count}`);
              if (tierIndex >= Number(count) && filled)
                fail(`Round ${r} ${tierLabels[tier]} Hiring Manager must be empty when Number of Hiring Managers is ${count}`);
            });
          }
        } else {
          // No count given — tiers must still be contiguous (no secondary without primary)
          const filledTiers = ['primary', 'secondary', 'tertiary'].map(tier => this.isCsvCellFilled(row, roundHeaders[tier]));
          if ((filledTiers[1] && !filledTiers[0]) || (filledTiers[2] && !filledTiers[1]))
            fail(`Round ${r} Hiring Managers must be filled in order: Primary, then Secondary, then Tertiary`);
        }

        // Single-value columns must not carry multiple roles
        ['slotApprover', 'primary', 'secondary', 'tertiary'].forEach(key => {
          const header = roundHeaders[key];
          if (header && this.isCsvCellFilled(row, header) && this.splitCsvRoles(this.csvCellValue(row, header)).length > 1)
            fail(`"${header.trim()}" must contain a single HRIS Unique Role`);
        });
      }

      return isValid;
    },
    validateInterviewRounds(row, rowIndex, headerMap) {
      const totalRounds = Number(this.csvCellValue(row, headerMap.base.rounds));

      if (!totalRounds || totalRounds < 1 || totalRounds > this.maxInterviewRounds) {
        this.logFailedRow(rowIndex, `Interview Rounds* must be atleast 1 or at most ${this.maxInterviewRounds}`, row);
        return false;
      }

      let validRoundCount = 0;

      for (let r = 1; r <= totalRounds; r++) {
        const roundHeaders = headerMap.rounds[r] || {};
        const hasInterviewer = this.isCsvCellFilled(row, roundHeaders.interviewer);
        const hasManager = ['primary', 'secondary', 'tertiary', 'legacyManager']
          .some(key => this.isCsvCellFilled(row, roundHeaders[key]));

        // If either one has data → this round is valid
        if (hasInterviewer || hasManager) {
          validRoundCount++;
        }
        else {
          this.logFailedRow( rowIndex, `Interview round ${r} missing interviewer / hiring manager`, row );
        }
      }

      // Final rule check
      if (validRoundCount !== totalRounds) {
        this.logFailedRow(
          rowIndex,
          `Expected ${totalRounds} round(s) data but found ${validRoundCount}`,
          row
        );
        return false;
      }

      return true;
    },
    checkMatters(word) {
      // Check if the value is not empty, null, or undefined
      return word !== "" && word !== null && word !== undefined;
    },
    // Verify every referenced HRIS unique role against MDM (exact match, batched lookups)
    async fetchMDMRoleMap(names) {
      const seen = new Set();
      const uniqueNames = [];
      names.forEach(name => {
        const trimmed = String(name || '').trim();
        const lower = trimmed.toLowerCase();
        if (trimmed && !seen.has(lower)) {
          seen.add(lower);
          uniqueNames.push(trimmed);
        }
      });

      const roleMap = {};
      const CHUNK_SIZE = 8;
      for (let i = 0; i < uniqueNames.length; i += CHUNK_SIZE) {
        await Promise.all(uniqueNames.slice(i, i + CHUNK_SIZE).map(async name => {
          try {
            const response = await AudienceRolesController.getAudienceRolesFromMDM({ searchQuery: name, page: 1, pageSize: 20 });
            const match = (response?.results || []).find(
              item => String(item?.hrisUniqueRole || '').trim().toLowerCase() === name.toLowerCase()
            );
            if (match) roleMap[name.toLowerCase()] = match;
          } catch (error) {
            console.error(`MDM lookup failed for "${name}":`, error);
          }
        }));
      }
      return roleMap;
    },
    async validateRowsAgainstMDM(rows) {
      if (!rows?.length) return rows;
      const { base, rounds } = this.csvHeaderMap;
      const roundRoleColumns = [
        ['interviewer', 'Interviewer HRIS Unique Role'],
        ['slotApprover', 'Slot Approver'],
        ['primary', 'Primary Hiring Manager'],
        ['secondary', 'Secondary Hiring Manager'],
        ['tertiary', 'Tertiary Hiring Manager'],
        ['legacyManager', 'Decision Maker / Hiring Manager'],
      ];

      // Collect every role name referenced anywhere in the file, then resolve in batches
      const allNames = [];
      rows.forEach(row => {
        allNames.push(this.csvCellValue(row, base.hrisRole));
        Object.values(rounds).forEach(roundHeaders => {
          roundRoleColumns.forEach(([key]) => {
            if (roundHeaders[key]) allNames.push(...this.splitCsvRoles(this.csvCellValue(row, roundHeaders[key])));
          });
        });
      });
      this.mdmRoleMap = await this.fetchMDMRoleMap(allNames);

      return rows.filter((row, index) => {
        let isValid = true;
        const fail = reason => {
          this.logFailedRow(index + 1, reason, row);
          isValid = false;
        };

        const hrisRole = this.csvCellValue(row, base.hrisRole);
        const mdmRecord = this.mdmRoleMap[hrisRole.toLowerCase()];
        if (!mdmRecord) fail(`HRIS Unique Role* "${hrisRole}" not found in MDM`);
        else {
          const roleCell = this.csvCellValue(row, base.role);
          if (this.checkMatters(roleCell) && roleCell && String(roleCell).toUpperCase() !== 'NA' &&
              String(mdmRecord.role || '').trim().toLowerCase() !== String(roleCell).trim().toLowerCase())
            fail(`Role "${roleCell}" does not match MDM role "${mdmRecord.role}" for HRIS Unique Role "${hrisRole}"`);
        }

        Object.entries(rounds).forEach(([roundNumber, roundHeaders]) => {
          roundRoleColumns.forEach(([key, label]) => {
            if (!roundHeaders[key]) return;
            this.splitCsvRoles(this.csvCellValue(row, roundHeaders[key])).forEach(name => {
              if (!this.mdmRoleMap[name.toLowerCase()])
                fail(`Round ${roundNumber} ${label} "${name}" not found in MDM`);
            });
          });
        });

        return isValid;
      });
    },
    csvFileToJSON(file) {
      this.fileName = file.name;
      return new Promise((resolve, reject) => {
        try {
          let contents = [];
          let jsonData = [];
          this.removedRows = [];
          let chunkId = this.$store.state.userInfo.id + "---" + new Date().toISOString();

          Papa.parse(file, {
            header: false,
            skipEmptyLines: true,
            complete: (results) => {
              contents = results.data;
              if (!contents.length) {
                reject("File is empty or invalid.");
                return;
              }

              // 1. Remove empty headers
              let headers = contents[0].filter(h => h && h.trim() !== "");
              let indexMap = contents[0]
                .map((h, i) => (h && h.trim() !== "" ? i : null))
                .filter(i => i !== null);

              // De-duplicate repeated headers
              const seenHeaders = {};
              headers = headers.map(header => {
                const key = header.trim().toLowerCase();
                seenHeaders[key] = (seenHeaders[key] || 0) + 1;
                return seenHeaders[key] > 1 ? `${header} (${seenHeaders[key]})` : header;
              });

              // 2. Resolve headers to canonical keys; reject if mandatory columns are missing
              const headerMap = this.resolveCsvHeaderMap(headers);
              this.csvHeaderMap = headerMap;

              const missingColumns = this.mandatoryCsvFields
                .filter(([key]) => !headerMap.base[key])
                .map(([, label]) => label);
              if (missingColumns.length) {
                this.failedRows.push({
                  Reason: `Missing column(s): ${missingColumns.join(', ')}. Please use the latest template.`,
                  "Row Number": 1,
                });
                this.uploadingRolesDialog = true;
                resolve([]);
                return;
              }

              // 3. Read all rows, then validate
              const allRows = [];
              for (let rowIndex = 1; rowIndex < contents.length; rowIndex++) {
                let rowData = {};
                let cells = contents[rowIndex];

                for (let j = 0; j < indexMap.length; j++) {
                  const header = headers[j];
                  const colIndex = indexMap[j];
                  const cell = cells[colIndex];
                  rowData[header] = typeof cell === "string" ? cell.trimEnd() : cell;
                }
                rowData["chunkId"] = chunkId;
                allRows.push({ rowData, rowIndex });
              }

              // 4. Sr No. must be serial across the whole file — reject the file otherwise
              if (!this.validateSerialNumbers(allRows.map(({ rowData }) => rowData), headerMap)) {
                this.uploadingRolesDialog = true;
                resolve([]);
                return;
              }

              // 5. Per-row validation (mandatory fields, enums, round completeness)
              const rawRows = [];
              for (const { rowData, rowIndex } of allRows) {
                let isValidRow = this.validateMandatoryFields(rowData, rowIndex, headerMap);
                if (isValidRow && !this.validateRowEnums(rowData, rowIndex, headerMap)) isValidRow = false;
                if (isValidRow && !this.validateInterviewRounds(rowData, rowIndex, headerMap)) isValidRow = false;
                if (isValidRow) rawRows.push(rowData);
              }

              // 6. Duplicate HRIS Unique Role check — one row per role mapping,
              // so the same role appearing twice is always an error.
              const srNoHeader = headerMap.base.srNo;
              const hrisHeader = headerMap.base.hrisRole;
              const roleToSrNo = {};
              let hasDuplicates = false;
              for (const row of rawRows) {
                const role = this.csvCellValue(row, hrisHeader);
                const sr = this.csvCellValue(row, srNoHeader);

                if (!role) continue;

                if (!roleToSrNo[role]) {
                  roleToSrNo[role] = sr;
                } else {
                  this.failedRows.push({
                    "Reason": `Duplicate HRIS Unique Role* "${role}" found (Sr No ${roleToSrNo[role]} and ${sr})`,
                    ...row
                  });
                  hasDuplicates = true;
                }
              }
              if (hasDuplicates) {
                this.uploadingRolesDialog = true;
                resolve([]);
                return;
              }

              jsonData = rawRows;
              this.uploadingRolesDialog = true;
              resolve(jsonData);
            },

            error: (error) => {
              console.error("Papa Parse error:", error);
              reject(error);
            }
          });
        } catch (e) {
          console.error("Error in parsing:", e);
          reject(e);
        }
      });
    },
    filterNewRolesAgainstExisting(parsedRows, existingDataset) {
      try {
        // 1. Build a set of existing HRIS unique roles
        const existingRoles = new Set(
          existingDataset.map(e => e.HRIS_unique_role?.trim()?.toLowerCase())
        );

        const { base, rounds } = this.csvHeaderMap;
        const isYes = (row, header) => /^yes$/i.test(String(this.csvCellValue(row, header)));

        // 2. PROCESS CSV DATA → BACKEND FORMAT (mirrors the single-create payload)
        let finalRows = [];

        parsedRows.forEach((row, index) => {
          const hrisRole = this.csvCellValue(row, base.hrisRole);

          // Skip duplicates
          if (existingRoles.has(hrisRole.toLowerCase())) {
            this.logFailedRow(index, `Role already exists`, row)
            return;
          }

          const groupName = this.csvCellValue(row, base.departmentGroup);
          const groupRecord = (this.audienceRoleGroups || []).find(
            ({ name }) => String(name || '').toLowerCase() === groupName.toLowerCase()
          );
          const scopeValue = this.csvCellValue(row, base.scope);
          const canonicalScope = this.interviewerScopeList.find(
            name => name.toLowerCase() === String(scopeValue).toLowerCase()
          );
          const mdmRecord = (this.mdmRoleMap || {})[hrisRole.toLowerCase()] || {};

          // Round-wise fields — keys stay 1-based, values are arrays
          const interviewerRoundWise = {};
          const hiringManagerRoundWise = {};
          const slotApproverRoundWise = {};
          Object.entries(rounds).forEach(([round, roundHeaders]) => {
            const interviewers = this.splitCsvRoles(this.csvCellValue(row, roundHeaders.interviewer));
            if (interviewers.length) interviewerRoundWise[round] = interviewers;

            // Tiered columns first; fall back to the legacy single Decision Maker column
            const managers = ['primary', 'secondary', 'tertiary']
              .map(tier => this.splitCsvRoles(this.csvCellValue(row, roundHeaders[tier]))[0])
              .filter(Boolean);
            if (!managers.length && roundHeaders.legacyManager)
              managers.push(...this.splitCsvRoles(this.csvCellValue(row, roundHeaders.legacyManager)));
            if (managers.length) hiringManagerRoundWise[round] = managers;

            const approver = this.splitCsvRoles(this.csvCellValue(row, roundHeaders.slotApprover))[0];
            if (approver) slotApproverRoundWise[round] = [approver];
          });

          finalRows.push({
            HRIS_unique_role: hrisRole,
            HRIS_unique_role_code: this.csvCellValue(row, base.hrisCode),
            department_group: groupRecord?.name || groupName,
            audienceRoleGroupId: groupRecord?.id || '',
            department: this.csvCellValue(row, base.department),
            campaignId: this.csvCellValue(row, base.campaignId),
            level: this.csvCellValue(row, base.level),
            roles: this.csvCellValue(row, base.role) || mdmRecord.role || '',
            screeningRequired: isYes(row, base.screening),
            mainsRequired: isYes(row, base.mains),
            demoRequired: isYes(row, base.demo),
            interviewRounds: Number(this.csvCellValue(row, base.rounds)) || 1,
            interviewerHRISUniqueRolesRoundWise: interviewerRoundWise,
            hiringManagerHRISUniqueRolesRoundWise: hiringManagerRoundWise,
            interviewerScope: canonicalScope || scopeValue,
            interviewerSlotApproverRoundWise: slotApproverRoundWise,
            status: 'active',
            chunkId: row.chunkId,
          });
        });
        return finalRows;

      }
      catch (err) {
        console.error("Error filtering and mapping roles:", err);
        throw err;
      }
    },

    async processCSV(file) {
      try {
        const {data : { audienceRoles }} = await this.getAudienceRoles(true);
        this.bulkAudienceRolesJsonData = await this.csvFileToJSON(file, audienceRoles);
        this.bulkAudienceRolesJsonData = await this.validateRowsAgainstMDM(this.bulkAudienceRolesJsonData);
        this.bulkAudienceRolesJsonData = this.filterNewRolesAgainstExisting(this.bulkAudienceRolesJsonData, audienceRoles);

        this.successfullRowCount = this.bulkAudienceRolesJsonData.length;
        this.failedRowCount = this.failedRows.length;

        this.uploadBulkAudienceRoles = false;
      } catch (error) {
        console.error("Error processing CSV:", error);
      }
    },
    closeUploadBulkAudienceRoles() {
      this.uploadBulkAudienceRoles = false;
      this.formActionType = "Create";
    },
      logout() {
        AuthService.logout();
        this.$router.push("/login");
      },
      async downloadCSV(csvData, fileName) {
        const csv = Papa.unparse(csvData);
  
        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  
        if (navigator.msSaveBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          const link = document.createElement("a");
          if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", fileName);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        }
      },
  
      csvTemplateFields() {
        const fields = [
          'Sr No.',
          'Department Group*',
          'Department*',
          'HRIS Unique Role*',
          'Role',
          'Level*',
          'Campaign Id*',
          'Interviewer/ Hiring Manager Scope*',
          'Screening Required (Yes/ No)*',
          'Mains Required (Yes/ No)*',
          'Demo Required (Yes/ No)*',
          'No. of Interview Rounds*',
        ];
        for (let round = 1; round <= this.maxInterviewRounds; round++) {
          fields.push(
            `Round ${round} Interviewer HRIS Unique Role`,
            `Round ${round} Slot Approver`,
            'Number of Hiring Managers',
            `Round ${round} Primary Hiring Manager`,
            `Round ${round} Secondary Hiring Manager`,
            `Round ${round} Tertiary Hiring Manager`,
          );
        }
        return fields;
      },
      async downloadRoles() {
        const fileName = "hris_unique_roles.csv";
        const response = await this.getAudienceRoles(true);
        const audienceRoles = response.data.audienceRoles;

        const data = audienceRoles.map((role, index) => {
          const row = [
            index + 1,
            role.department_group || 'NA',
            role?.department || 'NA',
            role.HRIS_unique_role || 'NA',
            role.roles || 'NA',
            role.level || 'NA',
            role.campaignId || 'NA',
            role.interviewerScope || 'NA',
            role.screeningRequired ? 'Yes' : 'No',
            role.mainsRequired ? 'Yes' : 'No',
            role.demoRequired ? 'Yes' : 'No',
            role?.interviewRounds || 1,
          ];

          for (let round = 1; round <= this.maxInterviewRounds; round++) {
            const managers = role.hiringManagerHRISUniqueRolesRoundWise?.[round] || [];
            row.push(
              this.roundWiseCsvCell(role.interviewerHRISUniqueRolesRoundWise, round),
              this.roundWiseCsvCell(role.interviewerSlotApproverRoundWise, round),
              managers.length || 'NA',
              managers[0] || 'NA',
              managers[1] || 'NA',
              managers[2] || 'NA',
            );
          }
          return row;
        });

        this.downloadCSV({ fields: this.csvTemplateFields(), data }, fileName);
      },

      async downloadSampleCSV() {

      let fileName = 'Role Mapping Master Template.csv'
      try {
        const response = await axios.get(`https://firebasestorage.googleapis.com/v0/b/vgos-sss-stag.appspot.com/o/audience_roles%2F${fileName}?alt=media`, {
          responseType: 'blob' // Important
        });
      
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      } catch (error) {
        console.error('Error downloading file:', error);
      }

    },
    downloadFailedRows() {
      if (!this.failedRows?.length) return;

      const wb = XLSX.utils.book_new();
      let wsData = [];

      // Extract headers from the FIRST row (except Reason)
      const rowKeys = Object.keys(this.failedRows[0]).filter(k => k !== "Reason");

      // Final headers = original headers + "Reason"
      const headers = [...rowKeys, "Reason"];
      wsData.push(headers);

      // Process each failed row
      this.failedRows.forEach(row => {
        // Build row in proper order
        const excelRow = rowKeys.map(key => row[key] ?? "");

        // Add Reason as last cell (full string, single column)
        excelRow.push(row.Reason || "");

        wsData.push(excelRow);
      });

      const ws = XLSX.utils.aoa_to_sheet(wsData);
      XLSX.utils.book_append_sheet(wb, ws, "Failed Uploads");

      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });

      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "failed_uploads.xlsx";
      link.click();
    },
      clearDataAndClose(){
        this.uploadingRolesDialog = false;
        this.bulkAudienceRolesJsonData = [];
        this.failedRows=[];
      },
      async closeUploadConfirmDialog(){
        await this.getAudienceRoles();
        this.showConfirmDialog = false;
      },
      getDate(timeStamp) {
        return this.formatDate(timeStamp);
      },
  
      createForm() {
        this.HRIS_unique_role = "",
        this.HRIS_unique_role_code = "",
        this.department = "",
        this.department_group = "",
        this.campaignId = "",
        this.level = "",
        this.levels = [],
        this.screeningRequired = false;
        this.mainsRequired = false;
        this.demoRequired = false;
        this.interviewRounds = 1;
        this.interviewerHRISUniqueRolesRoundWise = {};
        this.hiringManagerHRISUniqueRolesRoundWise = {};
        this.interviewerScope = "";
        this.slotApproverHRISUniqueRoleRoundWise = {};
        this.numberOfHiringManagersRoundWise = { 1: 1 };
        this.roles = "",
        this.audience_role = ""
        this.hrisUniqueRolesList = [];
        this.hrisUniqueRolesPage = 1;
        this.audienceRolesList = [];
        this.currentPage = 1;
        this.dialog = true;
        this.formActionType = 'Create';
      },
  
      async openActionDialog(item, actionType) {
        this.isInitializingForm = true;
        this.viewAudienceRolesDialog = false;
        this.HRIS_unique_role = item.HRIS_unique_role;
        this.HRIS_unique_role_code = item.HRIS_unique_role_code;
        this.department_group = this.audienceRoleGroups.find(({name}) => name === item.department_group)?.id || '';
        this.department = item.department || '';
        this.campaignId = item.campaignId || '';
        this.interviewRounds = item.interviewRounds;
        this.screeningRequired = item.screeningRequired;
        this.mainsRequired = item.mainsRequired;
        this.demoRequired = item.demoRequired;
        this.interviewerHRISUniqueRolesRoundWise = item.interviewerHRISUniqueRolesRoundWise || {};
        this.hiringManagerHRISUniqueRolesRoundWise = this.normalizeRoundWiseSchema(item.hiringManagerHRISUniqueRolesRoundWise);
        this.interviewerScope = item.interviewerScope || '';
        this.slotApproverHRISUniqueRoleRoundWise = Object.fromEntries(
          Object.entries(this.normalizeRoundWiseSchema(item.interviewerSlotApproverRoundWise)).map(
            ([round, approvers]) => [round, approvers[0] || '']
          )
        );
        // Number of hiring managers is UI-only state, derived from the stored arrays
        this.numberOfHiringManagersRoundWise = Object.fromEntries(
          Object.entries(this.hiringManagerHRISUniqueRolesRoundWise).map(
            ([round, managers]) => [round, Math.min(Math.max(managers.length, 1), 3)]
          )
        );
        this.ensureHiringManagerCountDefaults();
        this.level =  item.level;
        this.roles = item.roles;
        this.editId = item.id;
        // selected id for edit
        this.formActionType = actionType;
        this.dialog = true;

        // Fresh lists; seed rounds list with selections so their chips render before focus
        this.hrisUniqueRolesList = [];
        this.hrisUniqueRolesPage = 1;
        this.currentPage = 1;
        this.audienceRolesList = this.collectRoundSelections().map(role => ({ hrisUniqueRole: role, role: '' }));

        this.activeAutoCompleteId = 'hrisUniqueRole';
        // Snapshot from the translated UI state so DB->UI mapping doesn't register as a change
        this.formHash = this.getFormHash();
        await this.getAudienceRolesFromMDM();
        await this.handleDepartmentGroupChange();

        await this.$nextTick();
        this.isInitializingForm = false;
      },
  
      async saveInputs() {
        // checking case for update/create
        if (this.$refs.form.validate()) {
          this.loading = true;
          let response;
          if (this.formActionType === 'Create') {
            response = await AudienceRolesController.createAudienceRoles({
              HRIS_unique_role: this.HRIS_unique_role,
              HRIS_unique_role_code: this.HRIS_unique_role_code,
              department_group: this.departmentGroupName,
              audienceRoleGroupId: this.department_group,
              department: this.department,
              campaignId: this.campaignId,
              level: this.level,
              roles: this.roles,
              audience_role: this.audience_role,
              screeningRequired: this.screeningRequired,
              mainsRequired: this.mainsRequired,
              demoRequired: this.demoRequired,
              interviewRounds: this.interviewRounds,
              interviewerHRISUniqueRolesRoundWise: this.ensureArrayValues(this.interviewerHRISUniqueRolesRoundWise),
              hiringManagerHRISUniqueRolesRoundWise: this.normalizeRoundWiseSchema(this.hiringManagerHRISUniqueRolesRoundWise),
              interviewerScope: this.interviewerScope,
              interviewerSlotApproverRoundWise: this.normalizeRoundWiseSchema(this.slotApproverHRISUniqueRoleRoundWise),
              status: 'active',
            });
          }
          else if(this.formActionType === 'Update') {
            response = await AudienceRolesController.updateAudienceRole(
              {
                HRIS_unique_role: this.HRIS_unique_role,
                HRIS_unique_role_code: this.HRIS_unique_role_code,
                department_group: this.departmentGroupName,
                audienceRoleGroupId: this.department_group,
                department: this.department,
                campaignId: this.campaignId,
                level: this.level,
                roles: this.roles,
                audience_role: this.audience_role,
                screeningRequired: this.screeningRequired,
                mainsRequired: this.mainsRequired,
                demoRequired: this.demoRequired,
                interviewRounds: this.interviewRounds,
                interviewerHRISUniqueRolesRoundWise: this.ensureArrayValues(this.interviewerHRISUniqueRolesRoundWise),
                hiringManagerHRISUniqueRolesRoundWise: this.normalizeRoundWiseSchema(this.hiringManagerHRISUniqueRolesRoundWise),
                interviewerScope: this.interviewerScope,
                interviewerSlotApproverRoundWise: this.normalizeRoundWiseSchema(this.slotApproverHRISUniqueRoleRoundWise)
              },
              this.editId
            );
          }
          this.closeFormDialog()
          if (response.status == 200) {
            this.successDialog = true;
          }else if(response.status == 409){
            this.errorDialog = true;
            this.errorMessage = 'Role Mapping Already Exists';
          }
           else {
            this.errorDialog = true;
            this.errorMessage = response.data.error;
          }
          this.getAudienceRoles();
          this.loading = false;
        }
      },
      ensureArrayValues(obj){
        return Object.fromEntries(
          Object.entries(obj).map(([key, val])=>[key, (Array.isArray(val)? val : [val])])
        )
      },

      async deleteData(items) {
        let ids = [];
        items.forEach((doc) => {
          ids.push(doc.id);
        });
        this.dLoading = true;
        const response = await AudienceRolesController.deleteAudienceRole({
          ids: ids,
        });
        if (response.status == 200) {
          this.search = '';
          this.getAudienceRoles();
        } else {
          alert(response);
        }
  
        this.deleteDialog = false;
        this.dLoading = false;
        this.selected = [];
        this.deleteSuccessDialog = true;
      },
  
      async getAudienceRoles(shouldFetchAllData = false, hrisUniqueRoleQuery = '') {
        try {
        this.dataTableLoading = (shouldFetchAllData === false);
        const itemsPerPage = this.dataTableOptions.itemsPerPage;
        const pgNum = this.dataTableOptions.page;
        const searchQuery = hrisUniqueRoleQuery || this.search;
        const sortCol = this.sortCol;
        const sortOrder = this.sortOrder;
        const levels = this.selectedLevelFilter.join(',');
        const audienceRoleGroupId = this.selectedAudienceRoleGroupIds.join(',') || null;
        const params = {
          ...((shouldFetchAllData === false) ? {itemsPerPage} : {}),
          pgNum : ((shouldFetchAllData === false) ? pgNum : 1),
          ...((shouldFetchAllData === false) ? {searchQuery} : {}),
          sortCol,
          sortOrder,
          levels,
          audienceRoleGroupId,
        }
        const query = "?"+(new URLSearchParams(params)).toString()
        const response = await AudienceRolesController.getAudienceRoles(
         query,
        );
        if (response.status == 200) {
          this.dataTableLoading = false;
          if(shouldFetchAllData !==  true){
            this.tableData = response.data.audienceRoles;
            this.count = response.data.count;
          }
        } else {
          this.dataTableLoading = false;
          alert("Something went wrong");
        }
        return response;
      } catch (error) {
          console.log(error);
        }
    },
    async getCampaigns(){
      const queryParams = new URLSearchParams({
        cluster: this.$store.state.role.clusterName === "All Clusters" ? "All" : this.$store.state.role.clusterName,
        school: this.$store.state.role.schools,
        status: 'Live',
        audienceType: 'JOB_SEEKER',
        all: 'true',
      });

      const response = await CampaignController.getCampaigns("?"+queryParams.toString())
      this.campaignsList = response.data.campaigns.liveCampaign;
    },
    async getDepartmentsFromMDM(){
      try{
        const response = await AudienceRolesController.getDepartmentsFromMDM({ page: 1, pageSize: 200 });
        this.departmentsFromMDM = response?.results || [];
        this.departmentsList = this.departmentsFromMDM.map(({ department }) => department);
      }
      catch(error){
        console.error('Error fetching departments from MDM:', error);
      }
    },
      async getAudienceRolesFromMDM() {
        // prevent duplicate call
        if (this.getAutoCompleteLoader()) return;

        const isHrisUniqueRole = this.activeAutoCompleteId === 'hrisUniqueRole';
        const currentList = isHrisUniqueRole ? this.hrisUniqueRolesList : this.audienceRolesList;
        const page = isHrisUniqueRole ? this.hrisUniqueRolesPage : this.currentPage;

        this.setAutoCompleteLoader(true);

        try {
          const searchQuery = this.getAutoCompleteTag(this.tags) || "";
          const query = {
            searchQuery,
            ...(isHrisUniqueRole && { department: this.department }),
            page: Number(page),
            pageSize: this.pageSize || 20,
          };

          const response = await AudienceRolesController.getAudienceRolesFromMDM(query);
          const fetchedRoles = response.results || [];

          // Preserve only the selections relevant to this list
          const selections = isHrisUniqueRole
            ? (this.HRIS_unique_role ? [this.HRIS_unique_role] : [])
            : this.collectRoundSelections();

          const preserved = selections.map(role =>
            currentList.find(r => r.hrisUniqueRole === role) ||
            fetchedRoles.find(r => r.hrisUniqueRole === role) ||
            { hrisUniqueRole: role, role: '' }
          );

          const merged = this.mergeAudienceRoleItems(preserved, currentList, fetchedRoles);

          if (isHrisUniqueRole) {
            this.hrisUniqueRolesList = merged;
            this.hrisUniqueRolesHasMore = response.hasMore;
          } 
          else {
            this.audienceRolesList = merged;
            this.hasMoreData = response.hasMore;
          }

          // Observe last item for infinite scroll
          await this.$nextTick();
          this.observeLastTenthItem();
        } catch (err) {
          console.error("Error fetching roles:", err);
        } finally {
          this.setAutoCompleteLoader(false);
        }
      },
      collectRoundSelections(){
        const list = [];

        // Every round-wise HRIS role field (multi or single select)
        this.roundWiseRoleModelIds.forEach(fieldId => {
          Object.values(this[fieldId] || {}).forEach(val => {
            if (Array.isArray(val)) list.push(...val);
            else if (val) list.push(val);
          });
        });

        return [...new Set(list)];
      },
      mergeAudienceRoleItems(...lists) {
        return [...new Map(
          lists
            .flat()
            .filter(item => item?.hrisUniqueRole)
            .map(item => [item.hrisUniqueRole, item])
        ).values()];
      },
      initIntersectionObserver() {
        // clean up previous observer
        if (this.rolesScrollObserver) {
          try { this.rolesScrollObserver.disconnect(); } catch(e) {}
          this.rolesScrollObserver = null;
        }

        // if no menuContent yet, bail — mutation observer will call again when present
        if (!this.menuContent) return;

        // root should be the menuContent itself, not a query each time
        const rootEl = this.menuContent;

        // create observer (debounced callback is fine but 0 delay ok)
        this.rolesScrollObserver = new IntersectionObserver(async (entries) => {
          const entry = entries[0];
          if (!entry || !entry.isIntersecting) return;

          const elementIndex = parseInt(entry.target.dataset.index, 10);
          const elementId = this.getElementIdentifier(entry.target);

          if (this.observedElements.has(`${elementId}-${elementIndex}`)) return;

          this.observedElements.add(`${elementId}-${elementIndex}`);
          this.lastWatchedIndex = elementIndex;
          if (this.activeAutoCompleteId === 'hrisUniqueRole') {
            this.hrisUniqueRolesPage++;
          }
          else {
            this.currentPage++;
          }
          // call loader (guarded internally)
          await this.getAudienceRolesFromMDM();
        }, {
          root: rootEl,
          threshold: 0
        });
      },
      initMutationObserver() {
        // always disconnect previous
        if (this.mutationObserver) {
          try { this.mutationObserver.disconnect(); } catch(e){/* ignore */ }
          this.mutationObserver = null;
        }

        // create a new observer that tries to find the *currently active* menu content
        this.mutationObserver = new MutationObserver((mutations) => {
          // find the menu content for *active* autocomplete
          // prefer checking for active id; if not found, try generic active menu
          const selector = '.v-menu__content.menuable__content__active .v-select-list';
          const node = document.querySelector(selector);
          if (node) {
            // store the closest v-menu__content wrapper; this is our scoped container
            this.menuContent = node.closest('.v-menu__content') || node;
            // init intersection observer scoped to this.menuContent
            this.initIntersectionObserver();
            // once we've attached to the visible menu content, stop watching DOM
            this.mutationObserver.disconnect();
          }
        });

        this.mutationObserver.observe(document.body, {
          childList: true,
          subtree: true
        });

        // If menu already open (fast path), try to initialize immediately
        const immediateNode = document.querySelector('.v-menu__content.menuable__content__active .v-select-list');
        if (immediateNode) {
          this.menuContent = immediateNode.closest('.v-menu__content') || immediateNode;
          this.initIntersectionObserver();
          this.mutationObserver.disconnect();
        }
      },
      observeLastTenthItem() {
        let attempts = 0;
        const maxAttempts = 10;

        const delay = () => new Promise(res => setTimeout(res, 200 + 100 * attempts));

        const tryObserve = async () => {
          if (!this.menuContent) {
            if (attempts++ < maxAttempts) {
              await delay();
              return tryObserve();
            }
            return;
          }

          // query only inside the active menu content
          const items = this.menuContent.querySelectorAll('.v-list-item');
          const isHrisUniqueRole = this.activeAutoCompleteId === 'hrisUniqueRole';
          const activeList = isHrisUniqueRole ? this.hrisUniqueRolesList : this.audienceRolesList;
          const hasMore = isHrisUniqueRole ? this.hrisUniqueRolesHasMore : this.hasMoreData;

          // when the DOM list equals the accumulated roles length, we can observe
          if (items.length === activeList.length) {
            if (this.scrollPending) this.scrollMenuToTop();

            if (hasMore && items.length > 0) {
              const idx = items.length - 5;
              if (idx >= 0) {
                try { this.rolesScrollObserver?.disconnect(); } catch(e){}
                this.rolesScrollObserver?.observe(items[idx]);
              }
            }
            return;
          }

          if (attempts++ < maxAttempts) {
            await delay();
            tryObserve();
          } else {
            // give up after some attempts - avoids infinite loops
            return;
          }
        };

        tryObserve();
      },
      async onAutocompleteInteraction(id, round = null) {
        const isSameField = this.activeAutoCompleteId === id && this.activeAutoCompleteRound === round;
        if (!isSameField) {
          this.setAutoCompleteLoader(false);
        }

        // set context immediately
        this.activeAutoCompleteId = id;
        this.activeAutoCompleteRound = round;

        // reset scroll observers so previous menu doesn't interfere
        try { this.rolesScrollObserver?.disconnect(); } catch(e) {}
        try { this.mutationObserver?.disconnect(); } catch(e) {}

        // clear previous menuContent (we'll find the new one)
        this.menuContent = null;
        this.observedElements.clear();
        this.lastWatchedIndex = -1;

        await this.$nextTick()

        // start listening for the new menu DOM to appear
        this.initMutationObserver();

        // optionally preload only if nothing loaded for this field
        // (prefer not to fetch on focus in general — let typing trigger)
          // small delay may help if menu DOM not attached yet
          await this.$nextTick();
          await this.getAudienceRolesFromMDM();
      },
      scrollMenuToTop() {
        if(this?.menuContent?.length > 0){
            let element = this.menuContent[0];
            element.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
          this.scrollPending = false
        } else {
          this.scrollPending = true
        }
      },
      // Custom filter as autocomplete require a field to search, for fields use custom filter
      customFilter (item, queryText, itemText) {
        const hrisUniqueRole = item.hrisUniqueRole?.toLowerCase()
        const role = item.role.toLowerCase()
        const searchText = queryText.toLowerCase()
        return hrisUniqueRole?.indexOf(searchText) > -1 ||
          role.indexOf(searchText) > -1
      },
      getElementIdentifier(element) {
        // Generate unique ID based on element properties
        return element.className + '_' + element.textContent.slice(0, 20) + '_' + element.offsetTop;
      },
      resetAutoComplete(){
          if (this.activeAutoCompleteId === 'hrisUniqueRole') {
            this.hrisUniqueRolesPage = 1;
            this.hrisUniqueRolesList = [];
          } 
          else {
            this.currentPage = 1;
            this.audienceRolesList = [];
          }
          this.observedElements.clear();
          this.lastWatchedIndex = -1;
        },
      debouncedTagsChange(type, round = null) {
        let target;

        // determine which debouncer bucket to use
        if (round === null) target = this.tagsDebouncer[type];
        else {
          if (!this.tagsDebouncer[type][round]) {
            this.$set(this.tagsDebouncer[type], round, null);
          }
          target = this.tagsDebouncer[type][round];
        }

        // create debouncer IF none exists for this scope
        if (!target) {
          const fn = debounce(async () => {
            const isSearchEmpty = !this.getAutoCompleteTag(this.tags);

            if (isSearchEmpty) {
              await this.getAudienceRolesFromMDM();
              this.menu = false;
            } else {
              this.resetAutoComplete();
              await this.getAudienceRolesFromMDM();
              this.scrollMenuToTop();
            }
          }, 500);

          // access seperate debounced functions for each field
          if (round === null) this.tagsDebouncer[type] = fn;
          else this.tagsDebouncer[type][round] = fn;

          target = fn;
        }

        target();
      },
      async handleAudienceRoleChange(){
        const selectedHrisUniqueRole = this.hrisUniqueRolesList.find(audienceRole=>audienceRole?.hrisUniqueRole === this.HRIS_unique_role);
        this.roles = selectedHrisUniqueRole?.role || '';
        this.HRIS_unique_role_code = selectedHrisUniqueRole?.hrisUniqueRoleCode || '';
      },
      getAutoCompleteLoader() {
        if(!this.activeAutoCompleteId) return false;

        if (this.activeAutoCompleteId === 'hrisUniqueRole') {
          return this.loadingRoles.hrisUniqueRole;
        }

        const store = this.loadingRoles[this.activeAutoCompleteId];
        const round = this.activeAutoCompleteRound;

        return store[round] ?? false;
      },
      setAutoCompleteLoader(value) {
        if (!this.activeAutoCompleteId) return;

        if (this.activeAutoCompleteId === 'hrisUniqueRole') {
          this.loadingRoles.hrisUniqueRole = value;
          return;
        }

        const store = this.loadingRoles[this.activeAutoCompleteId];
        const round = this.activeAutoCompleteRound;

        if (!store[round])
          this.$set(store, round, value);
        else
          store[round] = value;
      },
      getAutoCompleteTag(tags) {
        if (this.activeAutoCompleteId === 'hrisUniqueRole') {
          return tags.hrisUniqueRole;
        }
        const store = tags[this.activeAutoCompleteId];
        return (store && store[this.activeAutoCompleteRound]) || '';
      },
      sortByAlphabet(array, key) {
        (array || []).sort(function (a, b) {
          let nameA = a[key].toUpperCase(); // Convert to uppercase to ensure case-insensitive sorting
          let nameB = b[key].toUpperCase();
  
          if (nameA < nameB) {
            return -1;
          }
  
          if (nameA > nameB) {
            return 1;
          }
  
          return 0;
        });
        return array;
      },
      clearFilter() {
        this.selectedLevelFilter = [];
        this.selectedDepartmentFilters = [];
        this.selectedSort = "HRISAsc";
        this.sortCol = "HRIS_unique_role";
        this.sortOrder = "asc";
        this.getAudienceRoles();
        this.filterData = false;
        this.appliedFilter = false;
        this.filterCount = 0;
        this.filterDialog = false;
      },
      async filterAudienceRoles() {
        this.selectedSort = "HRISAsc";
        this.sortCol = "HRIS_unique_role";
        this.sortOrder = "asc";
        this.isFilterLoading = true;
        const response = await this.getAudienceRoles();
        if (response.status == 200) {
          this.filterDialog = false;
          this.tableData = response.data.audienceRoles
          this.count = response.data.count;
          this.filterData = true;
          this.isFilterLoading = false;
          this.appliedFilter = true;
        } else {
          alert(response.alert.error);
          this.isFilterLoading = false;
        }
      },
  
      getFilterCount() {
        this.filterCount = 0;
        if (this.selectedLevelFilter.length > 0) {
          this.filterCount += this.selectedLevelFilter.length
        }
        if (this.selectedDepartmentFilters.length > 0) {
          this.filterCount += this.selectedDepartmentFilters.length
        }
      },
      async getAudienceRoleGroups(){
        const response = await AudienceRolesController.getAudienceRoleGroups();
        if(response.status==200){
          this.audienceRoleGroups = response.data.audienceRoleGroup;
        }
      },
      async handleDepartmentGroupChange() {
        const response = await LevelController.getLevelByGroupName(this.department_group);
        this.levels = response?.data?.levels || [];
      },
      async handleDepartmentChange(){
        this.hrisUniqueRolesPage = 1;
        this.hrisUniqueRolesList = [];
        this.HRIS_unique_role = '';
        this.roles = '';
        this.HRIS_unique_role_code = '';
        this.activeAutoCompleteId = 'hrisUniqueRole';
        await this.getAudienceRolesFromMDM();
      },
      handleInterviewRoundsChange(newCount){
        const rounds = Number(newCount);
        // Ignore transient/invalid values (e.g. field cleared mid-edit) — nothing to prune yet
        if (!Number.isInteger(rounds) || rounds < 1) return;

        const clampedCount = Math.min(rounds, this.maxInterviewRounds);
        this.pruneAllRoundWiseState(clampedCount);
        this.ensureHiringManagerCountDefaults();
        this.initDynamicTags();
      },
      pruneAllRoundWiseState(newCount) {
        this.roundWiseRoleModelIds.forEach(fieldId => this.pruneInterviewRounds(this[fieldId], newCount));
        this.pruneInterviewRounds(this.numberOfHiringManagersRoundWise, newCount);

        this.roundWiseSearchFieldIds.forEach(fieldId => {
          this.pruneInterviewRounds(this.tags[fieldId], newCount);
          this.pruneInterviewRounds(this.tagsDebouncer[fieldId], newCount);
          this.pruneInterviewRounds(this.loadingRoles[fieldId], newCount);
        });
      },
      handleHiringManagerCountChange(round) {
        let count = Math.trunc(Number(this.numberOfHiringManagersRoundWise[round]));
        if (!count || count < 1) count = 1;
        else if (count > 3) count = 3;
        this.$set(this.numberOfHiringManagersRoundWise, round, count);

        // Drop selections of hidden tiers so those roles become selectable again
        const managers = this.hiringManagerHRISUniqueRolesRoundWise[round];
        if (Array.isArray(managers) && managers.length > count) managers.splice(count);
      },
      ensureHiringManagerCountDefaults() {
        for (let round = 1; round <= this.interviewRoundsCards; round++) {
          if (![1, 2, 3].includes(Number(this.numberOfHiringManagersRoundWise[round])))
            this.$set(this.numberOfHiringManagersRoundWise, round, 1);
        }
      },
      getHiringManager(round, tier) {
        return (this.hiringManagerHRISUniqueRolesRoundWise[round] || [])[tier] || '';
      },
      setHiringManager(round, tier, value) {
        if (!Array.isArray(this.hiringManagerHRISUniqueRolesRoundWise[round]))
          this.$set(this.hiringManagerHRISUniqueRolesRoundWise, round, []);
        this.$set(this.hiringManagerHRISUniqueRolesRoundWise[round], tier, value || '');
      },
      visibleHiringManagersForRound(round) {
        const count = Number(this.numberOfHiringManagersRoundWise[round]) || 0;
        const managers = this.hiringManagerHRISUniqueRolesRoundWise[round] || [];
        return Array.from({ length: count }, (_, tier) => managers[tier]);
      },
      hiringManagerItemsForRound(round, selectionsToDisable) {
        const baseItems = this.roundWiseAudienceRoleItems[round] || this.audienceRolesList;
        const disabledRoles = (selectionsToDisable || []).filter(Boolean);
        if (!disabledRoles.length) return baseItems;
        return baseItems.map(item =>
          disabledRoles.includes(item.hrisUniqueRole) ? { ...item, disabled: true } : item
        );
      },
      normalizeRoundWiseSchema(roundWiseData) {
        return Object.fromEntries(
          Object.entries(roundWiseData || {}).map(([round, val]) => [
            Number(round),
            (Array.isArray(val) ? val : [val]).filter(Boolean),
          ])
        );
      },
      // CSV cell for a round-wise field: joins arrays, tolerates legacy scalar values,
      // and treats an empty array as missing (falls back to 'NA').
      roundWiseCsvCell(roundWiseData, round) {
        const val = roundWiseData?.[round];
        const str = Array.isArray(val) ? val.filter(Boolean).join(', ') : val;
        return str || 'NA';
      },
      async initDynamicTags() {
        this.unwatchTags.forEach(fn => fn()); // stop old watchers
        this.unwatchTags = [];

        // Single-select autocompletes keep their displayed text in search-input;
        // resetting it to '' visually blanks a populated field (e.g. on edit-open).
        // Seed from the current selection instead — Vuetify writes the selection
        // text back into search-input after a pick anyway.
        const currentSelectionFor = {
          interviewerHRISUniqueRolesRoundWise: () => '', // multi-select renders chips
          slotApproverHRISUniqueRoleRoundWise: round => this.slotApproverHRISUniqueRoleRoundWise[round] || '',
          primaryHiringManagerHRISUniqueRolesRoundWise: round => this.getHiringManager(round, 0),
          secondaryHiringManagerHRISUniqueRolesRoundWise: round => this.getHiringManager(round, 1),
          tertiaryHiringManagerHRISUniqueRolesRoundWise: round => this.getHiringManager(round, 2),
        };

        for (let round = 1; round <= this.interviewRoundsCards; round++) {
          this.roundWiseSearchFieldIds.forEach(fieldId => {
            const selectionOf = currentSelectionFor[fieldId];
            this.$set(this.tags[fieldId], round, selectionOf ? selectionOf(round) : '');
          });

          await this.$nextTick();

          this.roundWiseSearchFieldIds.forEach(fieldId => {
            const unwatch = this.$watch(
              () => this.tags[fieldId][round],
              (newVal, oldVal) => {
                // Ignore Vuetify internal resets and no-op changes
                if (newVal === null) return;
                const prev = oldVal ?? '';
                const curr = newVal ?? '';
                if (prev === curr) return;

                // Only act for the active field + round
                if (this.activeAutoCompleteId === fieldId && this.activeAutoCompleteRound === round)
                  this.debouncedTagsChange(fieldId, round);
              }
            );
            this.unwatchTags.push(unwatch);
          });
        }
      },
      restrictInterviewRounds(value) {
        const rounds = Number(value);
        if (rounds < 1) this.interviewRounds = 1;
        else if (rounds > this.maxInterviewRounds) this.interviewRounds = this.maxInterviewRounds;
      },
      pruneInterviewRounds(targetData, newCount) {
        Object.keys(targetData).forEach(key => {
          if (Number(key) > Number(newCount)) this.$delete(targetData, key);
        });
      },
      limitInterviewersSelection(round) {
        const currentRoundInterviewers = this.interviewerHRISUniqueRolesRoundWise[round];
        if (currentRoundInterviewers.length > this.interviewRoleSelectionLimit) {
          this.interviewerHRISUniqueRolesRoundWise[round] = currentRoundInterviewers.slice(0, this.interviewRoleSelectionLimit);
        }
      },
      deleteChip(item, array) {
        let index = array.indexOf(item);
        array.splice(index, 1);
      },
      getAudienceRoleName(id) {
        const role = this.audienceRoleGroups.find(role => role.id === id);
        return role ? role.name : "-";
      },
    },
  };
  </script>
  
  <style scoped>
  .fixBar {
    position: fixed;
    z-index: 200;
    top: 0;
    width: 99.8%;
    padding-top: 4px;
  }
  .download-btn-icon{
    padding: 10px 20px !important;
    background-color: #E1E8F5 !important;
  }
  .sub-header{
    gap: 100px;
  }
  .interview-rounds-card{
    border: 0.5px solid #E0E0E0;
    box-shadow: 0px 2px 8px 0px #0000001A;
  }
  .form-card{
    height: calc(100vh - 236px) !important;
  }
  .view-form-card{
    height: calc(100vh - 180px) !important;
  }
  .form-action-bar{
    position:sticky;
    z-index: 100;
    width: 100% !important;
    height: 72px;
    background: var(--white) !important;
    border-top: 1px solid #0000001F;
  }
  .multi-line-ellipsis{
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: auto;
    max-width: 120px;
  }
  .widened-multi-line-ellipsis{
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: auto;
    max-width: 240px;
  }
  .custom-data-table >>> .v-data-table__wrapper {
    overflow-y: auto !important;
    scrollbar-width: none !important; /* Firefox */
    -ms-overflow-style: none !important; /* IE and Edge */
  }
  .frozen-column-table {
    width: 100%;
    overflow-x: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .frozen-column-table >>> thead {
    position: sticky !important;
    top: 0 !important;
    z-index: 50 !important;
  }

  .frozen-column-table >>> .v-data-table__wrapper {
    overflow-x: auto;
    -ms-overflow-style: none !important;
    scrollbar-width: none !important;
  }

  .frozen-column-table::-webkit-scrollbar {
    display: none;
  }
  .frozen-column-table >>> th:first-child,
  .frozen-column-table >>> td:first-child {
    border-bottom: 1px solid var(--gray-03)!important;
    position: sticky !important;
    left: 0 !important;
    z-index: 10 !important;
    background-color: white;
    white-space: nowrap;
    width: 48px !important;
    min-width: 48px !important;
    max-width: 48px !important;
  }

  .frozen-column-table >>> th:nth-child(2),
  .frozen-column-table >>> td:nth-child(2) {
    border-bottom: 1px solid var(--gray-03)!important;
    position: sticky !important;
    left: 48px !important;
    z-index: 9 !important;
    background-color: white;
    white-space: nowrap;
    box-shadow: 5px 0 8px -3px rgba(0, 0, 0, 0.1) !important;
  }

  .frozen-column-table >>> th.actions-column,
  .frozen-column-table >>> td.actions-column {
    border-bottom: 1px solid var(--gray-03)!important;
    position: sticky!important;
    right: 0;
    z-index: 7;
    background-color: white;
    box-shadow: -5px 0 8px -3px rgba(0, 0, 0, 0.1) !important;
    padding: 0 12px !important;
    text-align: center !important;
  }

  .frozen-column-table >>> tbody tr:hover td:first-child,
  .frozen-column-table >>> tbody tr:hover td:nth-child(2),
  .frozen-column-table >>> tbody tr:hover td.actions-column {
    background-color: inherit!important;
  }
  
  .frozen-column-table >>> th:nth-child(1), 
  .frozen-column-table >>> th:nth-child(2),
  .frozen-column-table >>> th.actions-column {
    background-color: #ebf2ff;
  }
  .frozen-column-table >>> th.last-grouped-col,
  .frozen-column-table >>> td.last-grouped-col{
    border-right: 1px solid var(--gray-03)!important;
    border-left: 1px solid var(--gray-03)!important;
  }
  .frozen-column-table >>> th.grouped-col ,
  .frozen-column-table >>> td.grouped-col {
    border-left: 1px solid var(--gray-03)!important;
  }
  .frozen-column-table >>> thead th:hover,
  .frozen-column-table >>> thead th:hover * {
    color: var(--blue-01)!important;
  }
  .text-h6{
    font-size: 20px !important;
    font-family: 'GraphikMedium', sans-serif !important;
    font-weight: 500 !important;
  }
  .card-title-text{
    font-family: 'GraphikMedium', sans-serif !important;
    font-weight: 500 !important;
  }
  .v-input--selection-controls{
    margin: 0px !important;
    padding-top: 0px !important;
  }
  .v-input__slot{
    margin-bottom: 4px !important;
  }
  .view-mode-text{
    color: var(--gray) !important;
  }
  .form-title-text{
    color: var(--primary) !important;
  }
  </style>
